<template>
  <div class="wrapper footer">
    <div class="mycontentFooter">
      <div class="row noPadding">
        <div class="large-12 medium-12 columns legal">
          <div>

            <div class="footerNav nl-en">

              <div class="logo-footer"><a :href="`${Footer.main_link}`" target="_blank"><img
                    :src="`${Footer.logo}`" alt="Just eat takeaway.com"
                    title="Just eat takeaway.com"></a></div>

              <div class="_7vDDJp">
                <div class="lRffM0">
                  <section class="nctTd _3C_87 _1pbYw HffT- _33mNX nqc-L _1Ta_9" data-qa="toggler">
                    <div role="button" id="toggler-toggle_0" class="_2378e" tabindex="0" aria-expanded="true"
                      aria-controls="toggler-panel_0" data-qa="toggler-action-toggle" @click="openAcc($event)">
                      <div class="_1y1en">
                        <div>{{ MainNavFirst.colTitle }}</div>
                      </div><span class="_2g3EC"><span class="_21Vy- Jhc8N VrfUP" data-qa="icon"><svg viewBox="0 0 16 16"
                            width="1em" height="1em" role="presentation" focusable="false" aria-hidden="true">
                            <path
                              d="M13.18 10.97L8 5.615l-5.18 5.399-.962-.875 5.346-5.565a1.164 1.164 0 011.671 0l5.25 5.495-.945.901z">
                            </path>
                          </svg></span></span>
                    </div>
                    <div>
                      <div class="_9XIHk open">
                        <div class="_3Cp-I">
                          <div role="region" id="toggler-panel_0" class="xInyF" aria-hidden="false"
                            aria-labelledby="toggler-toggle_0" data-qa="toggler-panel">
                            <ul class="_2Yjfvh">
                              <li class="_3LSDXU" v-for="(item, ii) in MainNavFirst.subLinks" :key="`grid_${ii}`">
                                <a class="_3VpRA _2iLUA _1zoHE" tabindex="0" target="_blank"
                                  data-qa="text-link" :href="`${item.url}`" :title="`${item.text}`">
                                  <span class="_32z9BK">{{ item.text }}</span></a>
                                </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>


                <div class="_3PUwEk">
                  <section class="nctTd _3C_87 _1pbYw _3P1cW HffT- _33mNX nqc-L _1Ta_9" data-qa="toggler" v-for="(item, i) in MainNavSecond" :key="`grid_${i}`">
                    <div role="button" id="toggler-toggle_1" class="_2378e" tabindex="0" aria-expanded="true"
                      aria-controls="toggler-panel_1" data-qa="toggler-action-toggle"  @click="openAcc($event)">
                      <div class="_1y1en">
                        <div>{{ item.colTitle }}</div>
                      </div><span :class="i==0 ? '_2g3EC' : '_2g3EC open'"><span class="_21Vy- Jhc8N VrfUP" data-qa="icon"><svg viewBox="0 0 16 16"
                            width="1em" height="1em" role="presentation" focusable="false" aria-hidden="true">
                            <path
                              d="M13.18 10.97L8 5.615l-5.18 5.399-.962-.875 5.346-5.565a1.164 1.164 0 011.671 0l5.25 5.495-.945.901z">
                            </path>
                          </svg></span></span>
                    </div>
                    <div>
                      <div :class="i==0 ? 'open _9XIHk' : '_9XIHk'">
                        <div class="_3Cp-I">
                          <div role="region" id="toggler-panel_1" class="xInyF" aria-hidden="false"
                            aria-labelledby="toggler-toggle_1" data-qa="toggler-panel">
                            <ul class="_2Yjfvh _3QT5tG">
                              <li class="_3LSDXU" v-for="(item, i) in item.subLinks" :key="`grid_${i}`"><a class="_3VpRA _2iLUA _1zoHE" :href="`${item.url}`"
                                  target="_blank" :title="`${item.title}`" tabindex="0" data-qa="text-link"><span
                                    class="_32z9BK">{{  item.text }}</span></a></li>            
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>

                </div>
              </div>



              <div class="legalcopy2">
                <a v-for="(item, i) in Footer.links" :key="`grid_${i}`" :href="`${item.url}`" target="_blank">{{ item.text
                }}</a>
                <span class="devider"></span>
                <p>© {{ Footer.copyright }}</p>
              </div>

            </div>


          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
let lang = process.env.VUE_APP_LOCALITY;
import Content from "../data/content";

export default {
  name: 'Hero',
  methods: {
    async openAcc(event) {
      let acc = event.target.closest('._2378e');
      let svg = acc.getElementsByClassName('_2g3EC');
      let panel = acc.nextElementSibling;
      let dropdown = panel.getElementsByClassName('_9XIHk');
      dropdown[0].classList.toggle('open');
      svg[0].classList.toggle('open');
    }
  },
  data: function () {
    return {
      Footer: Content[lang].footer,
      MainNavFirst: Content[lang].footer.mainNavFirst,
      MainNavSecond: Content[lang].footer.mainNavSecond,
    }
  }
}
</script>

<style lang="scss">
$desktop: 1440px;
$tablet: 768px;
$mobile: 600px;

.footer {
  background: #EFEDEA;
  padding: 60px 0 30px;

  img {
    max-width: 100%;
  }
}

.mycontentFooter {
  position: relative;
  width: 100%;
  max-width: 1225px;
  margin: 0 auto;
}

.logo-footer {
  width: 100%;
  max-width: 365px;
  margin: 0 auto 50px;
  padding: 0;

  @media (max-widtH: $tablet) {
    width: calc(100% - 54px);
  }
}

.legalcopy2 {
  margin: 30px 0 0 0;
  text-align: center;
  padding-top: 35px;
  border-top: 1px solid rgba(0, 0, 0, 0.08);


  @media (max-widtH: $tablet) {
    display: flex;
    flex-wrap: wrap;
    margin: 0;
  }
}

.legalcopy2 p {
  margin: 16px 0;
  font-size: 14px;
  line-height: 21px;
  text-transform: none;
  text-align: center;
  color: #242E30;
  width: 100%;
}

.legalcopy2 a {
  display: inline-block;
  font-size: 15px;
  color: #242E30;
  padding: 10px 12px 16px 12px;
  text-decoration: none;

  @media (max-widtH: $tablet) {
    widtH: 100%;
    padding: 10px 0;
  }
}

.legalcopy2 a:last-of-type {
  padding: 10px 0 24px 16px;
}

.logo {
  display: inline-block;
  position: relative;
  z-index: 1005;
  top: 8px;
  width: 142px;
  height: auto;
}

.logo-at-size {
  top: 17px;
  width: 159px;
  height: 43px;
}

.logo-de-size {
  top: 17px;
  width: 159px;
  height: 43px;
}

.logo-de-at-size {
  top: 17px;
  width: 159px;
  height: 43px;
}

.logo-nl-size {
  top: 17px;
  width: 162px;
  height: 44px;
}

.logo-be-size {
  top: 17px;
  width: 156px;
  height: 42px;
}

.logo-pl-size {
  top: 17px;
  width: 123px;
  height: 40px;
}

.logo-eat-size {
  top: 17px;
  left: -1px;
  width: 163.3px;
  height: auto;
}

.logo-mob {
  display: none;
  width: 100%;
  max-width: 174px;
  position: absolute;
  left: 11px;
  top: 18px;
  color: #fff;
  margin: 0;
}

/*
.logo-mob:before {
  content: "î¥ƒ";
  font-family: fontello;
  width: 50%;
  display: flex;
  font-size: 27px;
  position: absolute;
  top: 10px;
}
*/



.backTop {
  z-index: 988;
  position: fixed;
  bottom: 20px;
  right: 0.83333rem;

  display: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  height: 3.5rem;
  width: 3.5rem;
  background: none;
  background-color: #fff;
  border: 1px solid #fff;
  border-radius: 50%;
  cursor: pointer;

  -webkit-box-shadow: 0 2px 4px 0 rgb(29 33 55 / 12%), 0 2px 4px 0 rgb(29 33 55 / 14%), 0 2px 4px 0 rgb(29 33 55 / 12%);
  box-shadow: 0 2px 4px 0 rgb(29 33 55 / 12%), 0 2px 4px 0 rgb(29 33 55 / 14%), 0 2px 4px 0 rgb(29 33 55 / 12%);

  padding: 0;
  color: #125fca;
  font: inherit;

  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  -webkit-transition: border-color .15s cubic-bezier(0, 0, .3, 1) 0s, background-color .15s cubic-bezier(0, 0, .3, 1) 0s, color .15s cubic-bezier(0, 0, .3, 1) 0s;
  transition: border-color .15s cubic-bezier(0, 0, .3, 1) 0s, background-color .15s cubic-bezier(0, 0, .3, 1) 0s, color .15s cubic-bezier(0, 0, .3, 1) 0s;
  animation: 0.7s ease-out 0s 1 bounceInUp forwards;
}

.backTop:hover {
  border: 1px solid #125FCA;
}

.backTop:after {
  content: "";
  position: absolute;
  z-index: 989;
  opacity: 1;
  width: .7em;
  height: .7em;
  left: calc(50% - 0.4em);
  top: calc(50% - 0.2em);
  transition: 0.3s;
  margin-right: 0px;
  margin-bottom: 0px;
  border-right: 3px solid #125FCA;
  border-top: 3px solid #125FCA;
  transform: rotate(-45deg);
}


.noselect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.footerNav {

  ._7vDDJp {
    display: flex;
    flex-wrap: wrap;

  }

  .lRffM0 {
    width: 24.19rem;

    @media only screen and (max-width :1280px) {
      max-width: calc(100% - 24px - 24px);
      widtH: 100%;
      margin: 0 auto;
    }
  }

  ._3PUwEk {
    max-width: calc(100% - 24.19rem - 24px);
    margin-left: 24px !important;

    @media only screen and (max-width :1280px) {
      width: 100%;
      max-width: calc(100% - 24px - 24px);
    }
  }
}


/* ################# */
/* ################# */
/* MEDIA QUERIES */



@media only screen and (max-width :1280px) {

  .mycontentTop {
    padding: 0 16px;
  }

  .mycontentFooter {
    padding: 0;
  }

  .mycontentFooter:after {
    width: calc(100% - 32px);
  }

  .legal {
    align-items: center;
    justify-content: space-between;
  }

  ._3C_87 {
    border-bottom: 1px solid rgba(0, 0, 0, 0.08) !important;
  }
}




// Old footer stuff
//
//
//
//
//
//


._2378e {
  padding: 12px 0;
  position: relative;

  &:hover {
    background: rgba(0, 0, 0, .04);
    cursor: pointer;
  }
}

._2g3EC {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

._2g3EC.open {
  transform: translateY(-50%) rotateX(180deg);
}

._1y1en {
  font-size: 20px;
  line-height: 45px;
  font-family: 'jet-extrabold';
}

._7vDDJp {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  display: -webkit-box;
  display: flex;
  flex-direction: column;
  width: 100%
}

._3C_87 {
  border-bottom: none;
}

._9XIHk {
  overflow: hidden;
  max-height: 0;

  &.open {
    max-height: none;
  }
}

._3LSDXU {
  margin-bottom: 24px;

  a {
    color: black;
    font-size: 14px;
    line-height: 20px;
  }
}

@media screen and (min-width: 1025px) {
  ._7vDDJp {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    flex-direction: row;
    padding-bottom: var(--xds-spacing-d)
  }
}

.lRffM0 {
  -webkit-box-flex: 0;
  flex: 0 0 auto;
  width: 100%
}

@media screen and (min-width: 1025px) {
  .lRffM0 {
    width: 24.19rem
  }
}

._3PUwEk {
  -webkit-box-flex: 1;
  flex: 1 1 auto;
  width: 100%
}

._3PUwEk ._3C_87 {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

._3PUwEk ._3C_87:last-of-type {
  border-bottom: none;
}


@media screen and (min-width: 1025px) {
  ._3PUwEk {
    max-width: calc(100% - 24.19rem - var(--xds-spacing-e))
  }

  .lRffM0+._3PUwEk {
    margin-left: var(--xds-spacing-e)
  }
}

._1oy6IS {
  max-width: 100%
}

._4_q7Xs {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -webkit-box-pack: center;
  display: -webkit-box;
  display: flex;
  flex-direction: row;
  justify-content: center;
  list-style: none;
  padding: 0
}

._2Yjfvh {
  list-style: none;
  margin: 0;
  padding: 0
}

@media screen and (min-width: 1025px) {
  ._2Yjfvh._3QT5tG {
    -webkit-column-count: 3;
    -moz-column-count: 3;
    column-count: 3;
    -webkit-column-gap: var(--xds-spacing-e);
    -moz-column-gap: var(--xds-spacing-e);
    column-gap: var(--xds-spacing-e);
    margin-bottom: calc(var(--xds-spacing-e)*-1)
  }
}

._2Yjfvh._3QT5tG ._32z9BK {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: break-spaces;
}

@-webkit-keyframes _2U2M7r {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2U2M7r {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _7b7Eew {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _7b7Eew {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2y9hLr {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2y9hLr {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3b0nq5 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3b0nq5 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.y3sqg7 {
  overflow: hidden
}

.y3sqg7 button>span {
  -webkit-box-align: center;
  align-items: center;
  display: -webkit-box;
  display: flex;
  width: 100%
}

.y3sqg7 button>span span:last-of-type {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap
}

@-webkit-keyframes rtKiGn {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes rtKiGn {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1Z7_Bm {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1Z7_Bm {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1N6r2L {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1N6r2L {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1k_qYT {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1k_qYT {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._28xnwl {
  background-color: var(--xds-color-container-strong);
  color: var(--xds-color-content-default);
  padding: var(--xds-spacing-c) 0
}

@media screen and (min-width: 1025px) {
  ._28xnwl {
    padding: var(--xds-spacing-d) var(--xds-spacing-f) var(--xds-spacing-e)
  }
}

._1FuUb1 {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-box-align: start;
  align-items: start;
  display: -webkit-box;
  display: flex;
  flex-direction: column;
  padding: var(--xds-spacing-c) var(--xds-spacing-d) var(--xds-spacing-b)
}

@media screen and (min-width: 1025px) {
  ._1FuUb1 {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -webkit-box-pack: center;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    padding: var(--xds-spacing-b) 0
  }
}

._31lafp {
  -webkit-box-pack: center;
  color: var(--xds-color-content-default);
  display: -webkit-box;
  display: flex;
  justify-content: center;
  padding: var(--xds-spacing-c) 0;
  white-space: nowrap
}

@media screen and (min-width: 1025px) {
  ._31lafp {
    padding: var(--xds-spacing-b) var(--xds-spacing-c)
  }
}

._2guuTL {
  color: var(--xds-color-content-default);
  display: -webkit-box;
  display: flex;
  padding: var(--xds-spacing-a) var(--xds-spacing-d) var(--xds-spacing-c);
  white-space: nowrap
}

@media screen and (min-width: 1025px) {
  ._2guuTL {
    -webkit-box-pack: center;
    justify-content: center;
    padding: var(--xds-spacing-b) var(--xds-spacing-c)
  }
}

._3nMfPQ {
  margin-bottom: var(--xds-spacing-i)
}

@media screen and (min-width: 1025px) {
  ._3nMfPQ {
    margin-bottom: 0
  }
}

@-webkit-keyframes _1pTNmS {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1pTNmS {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes EmYQFE {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes EmYQFE {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes rEeYGW {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes rEeYGW {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _25TSz_ {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _25TSz_ {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.juOwBv {
  -webkit-box-align: center;
  align-items: center
}

.juOwBv,
.LsJ3y9 {
  display: -webkit-box;
  display: flex
}

.LsJ3y9 {
  align-self: center;
  margin-right: var(--xds-spacing-b)
}

.LsJ3y9:hover {
  text-decoration: none
}

._17Gwrq {
  display: -webkit-box;
  display: flex
}

@media screen and (min-width: 721px) {
  ._17Gwrq {
    margin-left: var(--xds-spacing-c)
  }
}

@-webkit-keyframes _2IBUvZ {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2IBUvZ {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes HagXy0 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes HagXy0 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3yEa_9 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3yEa_9 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3_VgRS {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3_VgRS {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

#root {
  -webkit-box-orient: vertical;
  flex-direction: column;
  flex-grow: 1;
  overflow: hidden
}

#root,
._1IkfOK {
  -webkit-box-direction: normal;
  -webkit-box-flex: 1;
  display: -webkit-box;
  display: flex
}

._1IkfOK {
  -webkit-box-orient: horizontal;
  background-color: var(--xds-color-background-default);
  flex: 1 0 auto;
  flex-flow: row nowrap
}

._3STnj4 {
  padding: var(--xds-spacing-d);
  width: 100%
}

@-webkit-keyframes _2obSXA {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2obSXA {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes LlY-oA {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes LlY-oA {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3m1uyy {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3m1uyy {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _16MGk9 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _16MGk9 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._12LbDQ {
  margin-bottom: var(--xds-spacing-e)
}

._1pwywS {
  margin-bottom: 0
}

._1fr0VS {
  margin-bottom: var(--xds-spacing-e);
  margin-top: var(--xds-spacing-d)
}

@-webkit-keyframes _1YqmhJ {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1YqmhJ {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3zgmG0 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3zgmG0 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _14nMMQ {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _14nMMQ {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1gVMpV {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1gVMpV {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2Uw-j0 {
  margin-top: var(--xds-spacing-f);
  position: relative;
  text-align: center;
  width: 100%
}

@media screen and (min-width: 721px) {
  ._2Uw-j0 {
    margin-top: var(--xds-spacing-g)
  }
}

._3Zykuf {
  margin-bottom: var(--xds-spacing-d);
  margin-left: auto;
  margin-right: auto;
  text-align: left
}

@media screen and (min-width: 721px) {
  ._3Zykuf {
    margin-bottom: var(--xds-spacing-e);
    text-align: center
  }
}

._252sN_ {
  margin: auto
}

@-webkit-keyframes _3V3VxF {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3V3VxF {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes eTR6qv {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes eTR6qv {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _37KCok {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _37KCok {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1dEBF4 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1dEBF4 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2x8an4 a {
  text-decoration: underline
}

._2x8an4 a:hover {
  text-decoration: none
}

._2x8an4 img,
._2x8an4 video {
  height: auto;
  max-width: 100%
}

@-webkit-keyframes o3GI5s {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes o3GI5s {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3g6pqK {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3g6pqK {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1t3tJg {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1t3tJg {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2_poWu {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2_poWu {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.TjCNRs[title] {
  border: none;
  text-decoration: none
}

@-webkit-keyframes _2Ptjji {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2Ptjji {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1Rz0cU {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1Rz0cU {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3_hVnV {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3_hVnV {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1vEJe0 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1vEJe0 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1Dx1QO h3 {
  font-size: var(--xds-font-heading-l-size--wide);
  line-height: var(--xds-font-heading-l-line-height--wide)
}

@-webkit-keyframes _3-QCVR {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3-QCVR {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _22MREd {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _22MREd {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes dCzY_V {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes dCzY_V {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1S-vI6 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1S-vI6 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.a0DDcv {
  clip: rect(1px, 1px, 1px, 1px);
  -webkit-clip-path: inset(1px);
  clip-path: inset(1px);
  display: block;
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px
}

@-webkit-keyframes _2hhAu1 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2hhAu1 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1-rHup {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1-rHup {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes L63rbP {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes L63rbP {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2O6P1q {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2O6P1q {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@font-face {
  font-display: swap;
  font-family: JETSansDigital;
  font-style: normal;
  font-weight: 400;
  src: url(/consumer-web/fonts/normal.515c73f6.woff2) format("woff2")
}

@font-face {
  font-display: swap;
  font-family: JETSansDigital;
  font-style: normal;
  font-weight: 700;
  src: url(/consumer-web/fonts/700.aabc3a7d.woff2) format("woff2")
}

@font-face {
  font-display: swap;
  font-family: JETSansDigital;
  font-style: normal;
  font-weight: 800;
  src: url(/consumer-web/fonts/800.e7bf7626.woff2) format("woff2")
}

@-webkit-keyframes _1Gb9NP {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1Gb9NP {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes teUHnF {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes teUHnF {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1kPmMc {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1kPmMc {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1jLPzQ {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1jLPzQ {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.usabilla_live_button_container:has(style[nonce="302af10c4aeb"]) {
  z-index: var(--xds-z-index-notification) !important
}

@media screen and (min-width: 1025px) {
  .usabilla_live_button_container:has(style[nonce="302af10c4aeb"]) {
    bottom: -36px !important;
    left: 50% !important;
    top: unset !important;
    -webkit-transform: rotate(90deg) translateY(50%) !important;
    transform: rotate(90deg) translateY(50%) !important
  }
}

@media screen and (max-width: 1024px) {
  .usabilla_live_button_container:has(style[nonce="302af10c4aeb"]) {
    z-index: var(--xds-z-index-modal) !important
  }
}

@-webkit-keyframes _2JcH67 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2JcH67 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes Biu3w5 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes Biu3w5 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3ADVXJ {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3ADVXJ {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _296qz9 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _296qz9 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2nY7qY {
  width: 100%
}

.cL-miQ {
  height: 100%
}

@-webkit-keyframes _2p-vXS {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2p-vXS {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3FUEgS {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3FUEgS {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1_5jOz {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1_5jOz {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2nRixJ {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2nRixJ {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1EWsnT {
  color: var(--xds-color-content-light);
  position: relative;
  width: calc(var(--xds-spacing-d)*5)
}

._1EWsnT img {
  max-width: 100%
}

._3k0DBd {
  bottom: var(--xds-spacing-d);
  color: var(--xds-color-content-light);
  left: var(--xds-spacing-a);
  position: absolute
}

@media screen and (min-width: 1025px) {
  ._3k0DBd {
    bottom: 0;
    left: 0
  }
}

._3k0DBd img {
  border-radius: 5px
}

._3OutEG {
  position: static
}

._347b_s>:last-child {
  visibility: hidden
}

@-webkit-keyframes _1aOJfS {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1aOJfS {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes BZfkX7 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes BZfkX7 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes OuuHkY {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes OuuHkY {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3rim6y {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3rim6y {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3x6IUY {
  background: var(--xds-color-content-disabled);
  border-radius: var(--xds-radius-rounded-e);
  display: block;
  height: .13rem;
  margin: 0 var(--xds-spacing-a);
  width: .13rem
}

._3ZajH_ {
  bottom: .13rem;
  display: inline-block;
  position: relative
}

@-webkit-keyframes vQ6ZTn {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes vQ6ZTn {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2saMSy {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2saMSy {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _27ZJJG {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _27ZJJG {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes Mv_23x {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes Mv_23x {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2PRj3E {
  white-space: nowrap
}

._1qNLcT:after,
._35kkDM:before {
  content: "\A0"
}

@-webkit-keyframes _3nlI03 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3nlI03 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2mLRpl {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2mLRpl {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1HklBa {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1HklBa {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _11Kzt8 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _11Kzt8 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1pT_S8 {
  word-break: break-word
}

._1b3H-0 {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-box-pack: justify;
  align-content: flex-start;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  position: relative
}

._1b3H-0,
.zOaxX_ {
  display: -webkit-box;
  display: flex
}

.zOaxX_ {
  -webkit-box-pack: start;
  -webkit-box-align: center;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-bottom: var(--xds-spacing-a)
}

._15GZuC {
  margin-right: var(--xds-spacing-b)
}

._3qJIOu,
._15GZuC {
  display: inline-block;
  vertical-align: middle
}

@-webkit-keyframes EaTsON {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes EaTsON {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3ElwCY {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3ElwCY {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3bTp23 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3bTp23 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _CLle9 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _CLle9 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._15_98a {
  word-break: break-word
}

._38jJfX {
  height: 0;
  opacity: 0
}

@-webkit-keyframes _2Zb4Rv {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2Zb4Rv {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes KsmZ0u {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes KsmZ0u {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes eXpIPV {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes eXpIPV {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1Oc7hu {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1Oc7hu {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2uQAWr {
  min-height: calc(var(--xds-font-body-s-size)*var(--xds-line-height-reset))
}

._1BG9iR {
  color: var(--xds-color-content-default);
  margin: var(--xds-spacing-a)
}

._1BG9iR:hover {
  color: var(--xds-color-content-link-distinct)
}

._298EZf {
  margin: 0 calc(var(--xds-spacing-b) + 4px)
}

@media screen and (min-width: 721px) {
  ._298EZf {
    margin: 0 calc(var(--xds-spacing-f) + 4px)
  }
}

._1JWArT {
  color: var(--xds-color-content-light)
}

@-webkit-keyframes _3I6A0Z {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3I6A0Z {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes Ssi3pc {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes Ssi3pc {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2lT8jC {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2lT8jC {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes HhLZkh {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes HhLZkh {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1JMciQ {
  list-style: none;
  margin: 0;
  padding: 0
}

.ct6zm6+.ct6zm6 {
  margin-top: var(--xds-spacing-d)
}

._13JvY8 {
  height: 100%
}

@-webkit-keyframes _1bgapi {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1bgapi {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _22vemS {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3H5C-_ {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3H5C-_ {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2gIN00 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2gIN00 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3ro3-B {
  background-color: var(--xds-color-skeleton-02);
  overflow: hidden;
  position: relative
}

._3ro3-B:after {
  -webkit-animation: _22vemS 1s infinite;
  animation: _22vemS 1s infinite;
  background-image: -webkit-gradient(linear, left top, right top, color-stop(0, hsla(0, 0%, 100%, 0)), color-stop(20%, hsla(0, 0%, 100%, .2)), color-stop(60%, hsla(0, 0%, 100%, .5)), to(hsla(0, 0%, 100%, 0)));
  background-image: linear-gradient(90deg, hsla(0, 0%, 100%, 0), hsla(0, 0%, 100%, .2) 20%, hsla(0, 0%, 100%, .5) 60%, hsla(0, 0%, 100%, 0));
  bottom: 0;
  content: "";
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%)
}

@keyframes _22vemS {
  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

.pIR2uM {
  height: 1rem;
  width: 100%
}

._2mOqaW {
  height: 1rem;
  width: 80%
}

._2Ziloo {
  height: 1rem;
  margin-bottom: 1.25rem;
  width: 14.25rem
}

._1mQomx {
  height: 3rem;
  margin: auto;
  width: 3rem
}

@media screen and (min-width: 1025px) {
  ._1mQomx {
    height: 3.5rem;
    width: 3.5rem
  }
}

._3eMZZU {
  width: 5rem
}

@media screen and (min-width: 1025px) {
  ._3eMZZU {
    width: 10rem
  }
}

._25ghkh {
  padding: .81rem 0
}

._26mnc- {
  height: 1rem;
  width: 5rem
}

._2WXPNF {
  border-radius: 50%;
  height: 2rem;
  margin-right: var(--xds-spacing-b);
  width: 2rem
}

._133kaY {
  height: 1rem;
  width: 12rem
}

._1d2ASA+._1d2ASA {
  margin-top: var(--xds-spacing-b)
}

@media screen and (min-width: 1025px) {
  ._1d2ASA+._1d2ASA {
    margin-top: var(--xds-spacing-e)
  }
}

@-webkit-keyframes P_TpHC {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes P_TpHC {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes m10TjO {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes m10TjO {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2MYMsu {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2MYMsu {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1ZVfWv {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1ZVfWv {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1U2j7p {
  display: none
}

.Dg00Io {
  margin-top: -10px
}

@-webkit-keyframes _3Up090 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3Up090 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2JUS9M {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2JUS9M {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1OjRt8 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1OjRt8 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1nuelJ {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1nuelJ {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.hUSbG6 {
  margin-bottom: var(--xds-spacing-f)
}

._22-_Cf {
  color: var(--xds-color-content-subdued);
  margin: 0 0 var(--xds-spacing-b);
  padding: var(--xds-spacing-a) 0 var(--xds-spacing-b) var(--xds-spacing-e)
}

@-webkit-keyframes _22wm0S {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _22wm0S {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1JOFbb {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1JOFbb {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1s4j4X {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1s4j4X {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1A3Ir4 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1A3Ir4 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2--60H {
  height: 42px
}

@-webkit-keyframes _2b67_a {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2b67_a {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3w-4bD {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3w-4bD {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes -WLh2N {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes -WLh2N {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1Jvvum {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1Jvvum {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3CAQdn {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-box-align: center;
  align-items: center;
  display: -webkit-box;
  display: flex;
  flex-direction: column;
  margin: var(--xds-spacing-b) 0 var(--xds-spacing-e);
  width: 100%
}

@media screen and (min-width: 0) and (max-width:720px) {
  ._1Ti9wx {
    margin: 0 calc(var(--xds-spacing-d)*-1)
  }
}

@-webkit-keyframes _1V9w7b {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1V9w7b {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2K8ECK {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2K8ECK {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes UjMQaH {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes UjMQaH {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _34UG3m {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _34UG3m {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2Y72is {
  width: 306px
}

@-webkit-keyframes _1Z_S-u {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1Z_S-u {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2U5REm {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2U5REm {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _30gu1K {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _30gu1K {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes RYmul- {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes RYmul- {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3DI8LN {
  margin-top: var(--xds-spacing-c);
  width: 100%
}

@-webkit-keyframes _1vrnKg {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1vrnKg {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _34qygq {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _34qygq {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1uE-Wh {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1uE-Wh {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1DhZiX {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1DhZiX {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2Gvuro+._2Gvuro {
  margin-top: var(--xds-spacing-d)
}

@-webkit-keyframes _2fBKjC {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2fBKjC {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes IPOk4E {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes IPOk4E {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2jEljJ {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2jEljJ {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes IyDPPy {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes IyDPPy {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2qePIP:first-letter {
  text-transform: uppercase
}

@-webkit-keyframes _3KAuNd {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3KAuNd {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1cvk_q {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1cvk_q {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes IG2I_w {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes IG2I_w {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2eTn0z {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2eTn0z {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1e-1pe {
  height: 1px;
  width: 100%
}

._3zz93Q {
  position: relative;
  width: 100%
}

._1oKl_G {
  bottom: 0;
  left: 50%;
  min-height: var(--xds-spacing-e);
  position: absolute;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%)
}

@-webkit-keyframes _3NHM_9 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3NHM_9 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3UNfuZ {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3UNfuZ {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _7cjCWa {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _7cjCWa {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1Waq3e {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1Waq3e {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1Q_dPw {
  margin-bottom: var(--xds-spacing-d)
}

._14hL41 {
  margin: var(--xds-spacing-b) 0
}

._2nBT6L {
  width: 100%
}

._2nBT6L:first-of-type {
  margin-right: var(--xds-spacing-d)
}

._131M4S {
  margin: var(--xds-spacing-b) 0;
  width: 100%
}

@-webkit-keyframes _36O4sn {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _36O4sn {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes mfT3wU {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes mfT3wU {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3WUJhr {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3WUJhr {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _16deLs {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _16deLs {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2RuGUT {
  width: 120px
}

@media screen and (min-width: 1024px) {
  ._2RuGUT {
    min-width: 140px
  }
}

.zZYRPG {
  width: 80px
}

.Sh9ayd {
  margin-top: calc(var(--xds-spacing-d)*-1)
}

@-webkit-keyframes _1NyXrg {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1NyXrg {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes CHdI8g {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes CHdI8g {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes oZZzSp {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes oZZzSp {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes gKcEt9 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes gKcEt9 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._13n9Ba {
  height: 34rem;
  margin: 0 auto
}

._1Yu3PS {
  max-width: 34rem
}

.rLBZ50 {
  width: 100%
}

@-webkit-keyframes _1-7mo4 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1-7mo4 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1i8uaH {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1i8uaH {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1B66PL {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1B66PL {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2KtA2b {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2KtA2b {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2AdLYe {
  color: var(--xds-color-content-default);
  font-size: var(--xds-font-body-s-size);
  line-height: var(--xds-font-body-s-line-height)
}

@media screen and (min-width: 1024px) {
  ._2AdLYe {
    font-size: var(--xds-font-body-l-size);
    line-height: var(--xds-font-body-l-line-height)
  }
}

._2AdLYe p:first-of-type {
  margin-bottom: var(--xds-spacing-e);
  margin-top: 0
}

._2AdLYe ul {
  margin-bottom: var(--xds-spacing-e);
  margin-top: var(--xds-spacing-d)
}

._2AdLYe p:last-of-type {
  margin-bottom: 0
}

@-webkit-keyframes _2R5gCG {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2R5gCG {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3PK1Ur {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3PK1Ur {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1VC-SB {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1VC-SB {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1sJmLZ {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1sJmLZ {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1eRs3w {
  background-color: var(--xds-color-container-subtle);
  bottom: 0;
  -webkit-box-shadow: var(--xds-elevation-05);
  box-shadow: var(--xds-elevation-05);
  left: 0;
  min-width: 280px;
  padding: var(--xds-spacing-d);
  position: fixed;
  right: 0;
  z-index: var(--z-index-notification)
}

@-webkit-keyframes iD13oY {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes iD13oY {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1MjuIf {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1MjuIf {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2h7wMA {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2h7wMA {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2__CuW {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2__CuW {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@media screen and (min-width: 1025px) {
  ._1KIqUg {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: reverse;
    display: -webkit-box;
    display: flex;
    flex-direction: row-reverse;
    width: 100%
  }
}

._1KIqUg button:last-of-type {
  margin-top: var(--xds-spacing-d)
}

@media screen and (min-width: 1025px) {
  ._1KIqUg button:last-of-type {
    margin-right: var(--xds-spacing-d);
    margin-top: 0
  }
}

@-webkit-keyframes eIxTLG {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes eIxTLG {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2zQvMi {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2zQvMi {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1Re5w0 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1Re5w0 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3vaxb6 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3vaxb6 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3WLdXp {
  background-color: var(--xds-color-container-subtle);
  bottom: 0;
  -webkit-box-shadow: var(--xds-elevation-05);
  box-shadow: var(--xds-elevation-05);
  left: 0;
  padding: var(--xds-spacing-d);
  position: fixed;
  right: 0;
  z-index: var(--xds-z-index-notification)
}

@media screen and (min-width: 1024px) {
  ._3WLdXp {
    padding: var(--xds-spacing-f)
  }
}

@-webkit-keyframes _2i5NY- {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2i5NY- {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2xXvhg {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2xXvhg {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2XJDaw {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2XJDaw {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3GwX-k {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3GwX-k {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._14TCnh {
  background-color: var(--xds-color-background-default);
  bottom: 0;
  -webkit-box-shadow: var(--xds-elevation-05);
  box-shadow: var(--xds-elevation-05);
  left: 0;
  min-width: 280px;
  padding: var(--xds-spacing-f);
  position: fixed;
  right: 0;
  z-index: var(--z-index-notification)
}

.UuqTR7 {
  margin: 0 auto;
  width: 100%
}

@media screen and (min-width: 721px) {
  .UuqTR7 {
    max-width: 704px
  }
}

@media screen and (min-width: 1025px) {
  .UuqTR7 {
    max-width: 1008px
  }
}

@media screen and (min-width: 1281px) {
  .UuqTR7 {
    max-width: 1280px
  }
}

@media screen and (min-width: 1441px) {
  .UuqTR7 {
    max-width: 1424px
  }
}

._3oyoZG {
  margin-top: var(--xds-spacing-d)
}

@-webkit-keyframes _38Cndp {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _38Cndp {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes -kK0kl {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes -kK0kl {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3RCtFX {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3RCtFX {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes FJStbn {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes FJStbn {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3WpjYX {
  max-width: 1200px;
  width: 100%
}

@-webkit-keyframes _1YxllY {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1YxllY {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3U76fS {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3U76fS {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _24ikW8 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _24ikW8 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3qg2v6 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3qg2v6 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3nmvqn {
  max-width: 1200px;
  width: 100%
}

@-webkit-keyframes rrSBhP {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes rrSBhP {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2melF7 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2melF7 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2XgCZ2 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2XgCZ2 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2Oxwtx {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2Oxwtx {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2gQt3a {
  -webkit-box-flex: 1;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  background-color: var(--xds-color-container-default);
  display: -webkit-box;
  display: flex;
  flex: 1 0 auto;
  flex-flow: row nowrap;
  width: 100%
}

._3-I69t {
  background-color: var(--xds-color-background-default);
  padding: var(--xds-spacing-d);
  width: 100%
}

._3-I69t._2QXEKK {
  padding-top: 0
}

._3-I69t._3RwvF5 {
  padding: 0
}

._3-I69t.M-IfQv {
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0
}

._2PGcni,
._3-I69t.M-IfQv {
  background-color: var(--xds-color-container-default)
}

._2PGcni {
  -webkit-box-shadow: var(--xds-elevation-02);
  box-shadow: var(--xds-elevation-02);
  flex-shrink: 0;
  position: relative;
  width: 344px;
  z-index: var(--z-index-drawer)
}

._1QNDWY ._3-I69t,
.dey0uM ._3-I69t {
  width: 100%
}

@media screen and (min-width: 721px) {
  .dey0uM ._3-I69t {
    max-width: 704px
  }
}

@media screen and (min-width: 1025px) {
  .dey0uM ._3-I69t {
    max-width: 1008px
  }
}

@media screen and (min-width: 1281px) {
  .dey0uM ._3-I69t {
    max-width: 1280px
  }
}

@media screen and (min-width: 1441px) {
  .dey0uM ._3-I69t {
    max-width: 1424px
  }
}

@media screen and (min-width: 1025px) {

  .kB5WZ0 ._3-I69t,
  .kB5WZ0 .hr2D6P {
    max-width: calc(100% - 344px)
  }
}

._1zlCem {
  margin: var(--xds-spacing-h) auto
}

._1zlCem,
._3r0QKV {
  background-color: var(--xds-color-container-subtle)
}

@-webkit-keyframes _3xTwr4 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3xTwr4 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2lHjtK {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2lHjtK {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3e32Mw {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3e32Mw {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes VqeQeg {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes VqeQeg {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@media screen and (min-width: 1025px) {
  .hE7zbD {
    margin-top: -25px
  }

  ._2a6Fxy {
    margin-top: -50px
  }
}

@-webkit-keyframes _7rI-Bk {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _7rI-Bk {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1BscFH {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1BscFH {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2Ujn6i {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2Ujn6i {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2vHN_F {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2vHN_F {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._4Ekywn {
  margin: auto;
  max-width: 614px
}

@-webkit-keyframes _2fpUbP {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2fpUbP {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2qJMhf {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2qJMhf {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3mBPRx {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3mBPRx {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3nSwgO {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3nSwgO {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._209HeY button {
  margin: 0 5px 10px
}

@-webkit-keyframes _3vQRJy {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3vQRJy {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2NwTxN {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2NwTxN {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3eqswf {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3eqswf {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _4umAgh {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _4umAgh {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1wXHkD button {
  margin: 0 5px 10px
}

._2FZbgW {
  height: calc(var(--xds-spacing-e)*2);
  margin: var(--xds-spacing-d) 0 calc(var(--xds-spacing-d)*2);
  position: relative
}

@-webkit-keyframes _2d-bEB {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2d-bEB {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2tcSck {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2tcSck {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2Y37vh {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2Y37vh {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes J5oTUw {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes J5oTUw {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1HmVHK {
  display: -webkit-inline-box;
  display: inline-flex;
  min-height: var(--xds-icon-size-03)
}

._1HmVHK,
._20pBOL {
  -webkit-box-align: center;
  align-items: center
}

._20pBOL {
  -webkit-box-pack: center;
  background-color: transparent;
  border: var(--xds-border-regular) var(--xds-color-interactive-form);
  border-radius: var(--xds-radius-rounded-e);
  color: var(--xds-color-interactive-form);
  cursor: pointer;
  display: -webkit-box;
  display: flex;
  height: 22px;
  justify-content: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 22px
}

@media screen and (min-width: 721px) {
  ._20pBOL:hover {
    background-color: var(--xds-color-transparent--hover-01)
  }
}

._20pBOL:active {
  background-color: var(--xds-color-transparent--active-01)
}

._20pBOL:disabled {
  background-color: var(--xds-color-container-strong);
  border-color: transparent;
  cursor: default
}

._20pBOL svg {
  height: 12px;
  width: 12px
}

._2sbZgB {
  -webkit-box-align: center;
  -webkit-box-pack: center;
  align-items: center;
  background-color: var(--xds-color-interactive-brand);
  border-radius: var(--xds-radius-rounded-e);
  color: var(--xds-color-content-inverse);
  display: -webkit-box;
  display: flex;
  font-size: var(--xds-font-size-19);
  font-weight: var(--xds-font-weight-bold);
  height: var(--xds-icon-size-03);
  justify-content: center;
  line-height: var(--xds-font-size-16-line-height);
  margin: 0 var(--xds-spacing-a);
  min-width: var(--xds-icon-size-03);
  padding: 0 3px
}

._3bicl3 ._2sbZgB {
  min-width: 30px
}

@-webkit-keyframes _55SY3w {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _55SY3w {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _38UWqz {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _38UWqz {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2GICLj {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2GICLj {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1M_gfl {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1M_gfl {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2bWjtu main {
  color: var(--xds-color-content-default);
  font-size: 1em
}

._2bWjtu footer {
  color: var(--xds-color-content-subdued);
  font-size: .8em;
  margin-top: .5em
}

@-webkit-keyframes _3Shthd {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3Shthd {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _36M9uq {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _36M9uq {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _24PBrE {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _24PBrE {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1cP9JO {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1cP9JO {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3SeLwX {
  margin: auto;
  max-width: 1280px;
  padding: 0 var(--xds-spacing-d);
  width: 100%
}

@media screen and (min-width: 1280px) {
  ._3SeLwX {
    padding: 0 calc(var(--xds-spacing-a) + var(--xds-spacing-e))
  }
}

._1koDoc {
  display: none
}

@media screen and (min-width: 1024px) {
  ._1koDoc {
    display: block
  }
}

._21TXNf {
  min-height: calc(var(--xds-spacing-h) + var(--xds-spacing-g))
}

@-webkit-keyframes _1hr9_Z {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1hr9_Z {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1MvhQA {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1MvhQA {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1Lg9QK {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1Lg9QK {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _125yQG {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _125yQG {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@media screen and (min-width: 721px) {
  .pPmopN {
    margin-bottom: var(--xds-spacing-f)
  }
}

._32VTF7 {
  -webkit-box-align: baseline;
  align-items: baseline;
  display: -webkit-box;
  display: flex;
  max-width: 280px
}

@media screen and (min-width: 721px) {
  ._32VTF7 {
    margin-bottom: var(--xds-spacing-f);
    margin-top: var(--xds-spacing-e)
  }
}

._2c2ykB {
  max-width: 230px
}

._2PfK88 {
  -webkit-box-align: baseline;
  align-items: baseline;
  display: -webkit-box;
  display: flex;
  margin: var(--xds-spacing-d) 0 var(--xds-spacing-b);
  max-width: 280px
}

@media screen and (min-width: 721px) {
  ._2PfK88 {
    max-width: 370px
  }
}

@media screen and (min-width: 1024px) {
  ._2PfK88 {
    display: none
  }
}

._1yW1Gr {
  -webkit-box-align: center;
  align-items: center;
  display: none
}

@media screen and (min-width: 1024px) {
  ._1yW1Gr {
    -webkit-box-align: center;
    align-items: center;
    display: -webkit-box;
    display: flex;
    margin-top: var(--xds-spacing-e);
    width: 100%
  }
}

@-webkit-keyframes TZ5pD7 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes TZ5pD7 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3R2L01 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3R2L01 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3BMolC {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3BMolC {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3l45Hp {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3l45Hp {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1IXnZy {
  margin: auto;
  max-width: 1280px;
  width: 100%
}

@media screen and (min-width: 1280px) {
  ._1IXnZy {
    padding: 0 calc(var(--xds-spacing-a) + var(--xds-spacing-e))
  }
}

._3x7FDx {
  width: 100%
}

@-webkit-keyframes FKZy0_ {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes FKZy0_ {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3Q01go {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3Q01go {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _14oj_p {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _14oj_p {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _20hnWr {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _20hnWr {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2cAGK4 {
  margin-bottom: var(--xds-spacing-c);
  width: 100%
}

@media screen and (min-width: 721px) {
  ._2cAGK4 {
    margin-bottom: var(--xds-spacing-e);
    margin-right: var(--xds-spacing-e);
    width: calc(50% - var(--xds-spacing-e)/2)
  }

  ._2cAGK4:nth-child(2n) {
    margin-right: 0
  }
}

@media screen and (min-width: 1281px) {
  ._2cAGK4 {
    width: calc(25% - var(--xds-spacing-e)*3/4)
  }

  ._2cAGK4,
  ._2cAGK4:nth-child(2n) {
    margin-right: var(--xds-spacing-e)
  }

  ._2cAGK4:nth-child(4n) {
    margin-right: 0
  }
}

._2cAGK4 a {
  height: 100%;
  width: 100%
}

._2cAGK4 div {
  -webkit-box-align: center;
  align-items: center;
  display: -webkit-box;
  display: flex;
  height: 100%
}

@-webkit-keyframes _3R88vt {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3R88vt {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2r5C3D {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2r5C3D {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3gDyWP {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3gDyWP {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1TmJqx {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1TmJqx {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._34XcES {
  -webkit-box-pack: center;
  display: -webkit-box;
  display: flex;
  justify-content: center
}

@media screen and (min-width: 721px) {
  ._34XcES {
    -webkit-box-pack: start;
    justify-content: flex-start
  }
}

._34XcES span>svg {
  height: 215px;
  width: 285px
}

@-webkit-keyframes ay9ppe {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes ay9ppe {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1us3FU {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1us3FU {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes iTKRlx {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes iTKRlx {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes k0S4JJ {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes k0S4JJ {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.D4cYeQ {
  max-width: 518px;
  min-height: 350px
}

.D4cYeQ fieldset {
  padding: 0
}

@-webkit-keyframes PL2A0S {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes PL2A0S {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2UxVn6 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2UxVn6 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2-r7HU {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2-r7HU {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes Dd84nS {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes Dd84nS {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2yE_lt {
  margin-left: var(--xds-spacing-b);
  position: relative;
  top: -10px
}

@-webkit-keyframes _3wA0sv {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3wA0sv {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes NptEQO {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes NptEQO {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes T3R31w {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes T3R31w {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1mk2hk {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1mk2hk {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2pHlz6 fieldset {
  min-width: 0
}

._2pHlz6 label {
  max-width: 100%
}

._2pHlz6 legend span {
  white-space: normal
}

@-webkit-keyframes _23Cc8n {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _23Cc8n {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1FApvL {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1FApvL {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3w6Lwa {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3w6Lwa {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3bRCxf {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3bRCxf {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1Wnj1V {
  line-height: var(--xds-font-heading-s-line-height--wide);
  max-width: calc(100vw - 120px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap
}

@-webkit-keyframes _2mHd0y {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2mHd0y {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1XwFQP {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1XwFQP {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3n4S6k {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3n4S6k {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1FwHrV {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1FwHrV {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.ihnRVU {
  margin-bottom: var(--xds-spacing-e);
  width: 100%
}

@media screen and (min-width: 721px) {
  .ihnRVU {
    margin-right: var(--xds-spacing-e);
    width: calc(50% - var(--xds-spacing-e)/2)
  }

  .ihnRVU:nth-child(2n) {
    margin-right: 0
  }
}

@media screen and (min-width: 1281px) {
  .ihnRVU {
    width: calc(33.33333% - var(--xds-spacing-e)*2/3)
  }

  .ihnRVU:nth-child(2n) {
    margin-right: var(--xds-spacing-e)
  }

  .ihnRVU:nth-child(3n) {
    margin-right: 0
  }
}

._1U9gvV {
  height: 200px
}

@-webkit-keyframes A0WImE {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes A0WImE {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2qkBLc {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2qkBLc {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes dP81wC {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes dP81wC {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2d74s4 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2d74s4 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1amcy5 {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  display: -webkit-box;
  display: flex;
  flex-direction: column
}

@media screen and (min-width: 721px) {
  ._1amcy5 {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -webkit-box-align: stretch;
    -webkit-box-pack: justify;
    align-items: stretch;
    flex-direction: row;
    justify-content: space-between
  }
}

._1amcy5>div {
  width: 100%
}

@media screen and (min-width: 721px) {
  ._1amcy5>div {
    width: calc(50% - var(--xds-spacing-c))
  }
}

.nLVcGJ>div {
  width: 100%
}

@-webkit-keyframes _2cZtJj {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2cZtJj {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _14Sbuy {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _14Sbuy {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1cTQMp {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1cTQMp {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3yVEDz {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3yVEDz {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3pVY4X {
  margin: var(--xds-spacing-d) 0
}

@media screen and (min-width: 721px) {
  ._3pVY4X {
    width: 20rem
  }
}

@-webkit-keyframes _1_fLmw {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1_fLmw {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1Se8he {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1Se8he {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3C7SGa {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3C7SGa {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _122AbA {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _122AbA {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._27JDUD strong {
  font-size: var(--xds-font-body-l-size)
}

@-webkit-keyframes b3lRoA {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes b3lRoA {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3zaj-l {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3zaj-l {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1pYCJv {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1pYCJv {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3q1HFY {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3q1HFY {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.Qsg81P {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-box-pack: justify;
  display: -webkit-box;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  min-height: 70%
}

@media screen and (min-width: 1024px) {
  .Qsg81P {
    max-height: 32.4rem
  }
}

@-webkit-keyframes _2OrPMO {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2OrPMO {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes Kg4MQT {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes Kg4MQT {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes JnAg4F {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes JnAg4F {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2GMJBb {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2GMJBb {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3z5_is {
  margin: var(--xds-spacing-e) 0 0;
  padding-left: var(--xds-spacing-e)
}

@-webkit-keyframes u1zwHr {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes u1zwHr {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1EN_VW {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1EN_VW {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1MWCMt {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1MWCMt {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _32h4xS {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _32h4xS {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1PIpJ6 {
  margin-bottom: var(--xds-spacing-e)
}

@media screen and (min-width: 1025px) {
  ._1PIpJ6 {
    margin-bottom: 0;
    margin-right: 5rem;
    max-width: 31rem
  }
}

@-webkit-keyframes _3-stD6 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3-stD6 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _9ysgm8 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _9ysgm8 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3vbqvH {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3vbqvH {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3-JNaP {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3-JNaP {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.N1gws4 {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  color: var(--xds-color-content-default);
  display: -webkit-box;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: 23.75rem;
  padding: 0 var(--xds-spacing-d)
}

@media screen and (min-width: 1025px) {
  .N1gws4 {
    max-width: 67rem;
    padding: 0 var(--xds-spacing-d)
  }
}

._2HggWO {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  display: -webkit-box;
  display: flex;
  flex-direction: column
}

@media screen and (min-width: 1025px) {
  ._2HggWO {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    flex-direction: row
  }
}

._1CJXhN+._1CJXhN {
  margin-top: var(--xds-spacing-d)
}

@media screen and (min-width: 1025px) {
  ._1CJXhN+._1CJXhN {
    margin-left: var(--xds-spacing-d);
    margin-top: 0
  }
}

._3YYq_x {
  width: 10rem
}

@media screen and (min-width: 320px) {
  ._3YYq_x {
    position: relative;
    top: -1px
  }
}

@media screen and (min-width: 1025px) {
  ._3YYq_x {
    margin-top: var(--xds-spacing-f);
    width: 20rem
  }
}

._3-vLD2+._3YYq_x {
  margin-left: var(--xds-spacing-d)
}

._1m_vAI {
  font-size: var(--xds-font-heading-xxl-size--narrow);
  font-weight: var(--xds-font-heading-xxl-weight);
  line-height: var(--xds-font-heading-xxl-line-height--narrow)
}

@media screen and (min-width: 1025px) {
  ._1m_vAI {
    font-size: var(--xds-font-heading-xxl-size--wide);
    line-height: var(--xds-font-heading-xxl-line-height--wide)
  }
}

@-webkit-keyframes _2nLFBu {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2nLFBu {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes lq3ePi {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes lq3ePi {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1LWwye {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1LWwye {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _38hta1 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _38hta1 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3JD8Hh {
  -webkit-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
  margin: 0 var(--xds-spacing-d);
  overflow-wrap: anywhere
}

._1rPoeO {
  clip: rect(1px, 1px, 1px, 1px);
  -webkit-clip-path: inset(1px);
  clip-path: inset(1px);
  display: block;
  display: unset;
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px
}

@-webkit-keyframes _3hoJzy {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3hoJzy {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2uzOfJ {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2uzOfJ {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1oH03Y {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1oH03Y {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1tjk-9 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1tjk-9 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3F6W4U {
  word-break: break-word
}

.TlL696 {
  clip: rect(1px, 1px, 1px, 1px);
  -webkit-clip-path: inset(1px);
  clip-path: inset(1px);
  display: block;
  display: unset;
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px
}

.NE4LSP {
  background-color: var(--xds-color-support-info-02);
  border-radius: var(--xds-radius-rounded-b);
  color: var(--xds-color-content-subdued);
  display: inline-block;
  font-size: var(--xds-font-body-s-size);
  -webkit-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
  line-height: var(--xds-font-body-s-line-height);
  margin-top: var(--xds-spacing-a);
  overflow-wrap: break-word;
  padding: 2px var(--xds-spacing-a)
}

._3I8vuD {
  width: var(--xds-font-body-s-size)
}

@-webkit-keyframes _1i-_a3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1i-_a3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes ae67uE {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes ae67uE {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2mM2Eo {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2mM2Eo {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2SHlTx {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2SHlTx {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2nN4zt {
  clip: rect(1px, 1px, 1px, 1px);
  -webkit-clip-path: inset(1px);
  clip-path: inset(1px);
  display: block;
  display: unset;
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px
}

@-webkit-keyframes _3aTFWg {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3aTFWg {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2S_t13 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2S_t13 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes SLT4YR {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes SLT4YR {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1hfAZY {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1hfAZY {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.TXXHr7 {
  -webkit-box-align: center;
  align-items: center;
  display: -webkit-box;
  display: flex;
  height: calc(var(--xds-spacing-b)*13);
  margin: auto;
  max-width: 1072px;
  width: 100%
}

@media screen and (min-width: 0) and (max-width:1072px) {
  .TXXHr7 {
    padding: 0 var(--xds-spacing-d)
  }
}

._3DHd80 {
  -webkit-box-shadow: 0 0 4px var(--xds-color-border-subtle);
  box-shadow: 0 0 4px var(--xds-color-border-subtle);
  overflow: hidden
}

._3DHd80,
._324xd0 {
  max-width: 1072px;
  width: 100%
}

._324xd0 {
  height: 100%;
  margin: auto;
  margin-bottom: calc(var(--xds-spacing-e)*3)
}

._324xd0 iframe {
  border: 0
}

._2ogGCD {
  display: none
}

@media screen and (min-width: 1024px) {
  ._2ogGCD {
    display: block
  }
}

._25Du6D {
  -webkit-box-align: center;
  align-items: center;
  display: -webkit-box;
  display: flex;
  height: calc(var(--xds-spacing-a)*13);
  margin-bottom: var(--xds-spacing-f);
  width: 100%
}

@media screen and (min-width: 0) and (max-width:1025px) {
  ._324xd0 iframe {
    width: calc(100% - 1px)
  }

  ._25Du6D {
    margin-bottom: 0
  }

  .TXXHr7 {
    height: auto;
    padding: 0
  }

  .TXXHr7 ._3DHd80 {
    margin-bottom: 5px
  }
}

@-webkit-keyframes _1lKkeY {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1lKkeY {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2wrz12 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2wrz12 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _223jnE {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _223jnE {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3X_eDS {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3X_eDS {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.bXnXXX h1,
.bXnXXX h2 {
  border-bottom: var(--xds-border-width-regular) solid var(--xds-color-border-subtle)
}

.bXnXXX td {
  padding: var(--xds-spacing-b)
}

.bXnXXX p {
  text-align: justify
}

@-webkit-keyframes _36NO2Q {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _36NO2Q {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1BiG55 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1BiG55 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes cdVsw4 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes cdVsw4 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1siUB3 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1siUB3 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.ykZowW {
  margin-bottom: var(--xds-spacing-d)
}

._12w3QA {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  display: -webkit-box;
  display: flex;
  flex-direction: row
}

._1h-reJ {
  -webkit-box-flex: 1;
  border: 1px solid #d7d7d7;
  cursor: pointer;
  flex: 1;
  padding: .75rem
}

._1h-reJ:first-child {
  margin: 0 2rem 0 0
}

@-webkit-keyframes _2czFbD {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2czFbD {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes wFe-1l {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes wFe-1l {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3e-QbM {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3e-QbM {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes ETZgSW {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes ETZgSW {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2GeMKc {
  margin-bottom: var(--xds-spacing-d)
}

._3hMBNm {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  display: -webkit-box;
  display: flex;
  flex-direction: row
}

._26CGJE {
  -webkit-box-flex: 1;
  border: 1px solid #d7d7d7;
  cursor: pointer;
  flex: 1;
  padding: .75rem
}

._26CGJE:first-child {
  margin: 0 2rem 0 0
}

@-webkit-keyframes _3syoIq {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3syoIq {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes GmljAw {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes GmljAw {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1UHY-5 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1UHY-5 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1HFEG3 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1HFEG3 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3QqVmB h1,
._3QqVmB h2 {
  border-bottom: var(--xds-border-width-regular) solid var(--xds-color-border-subtle)
}

._3QqVmB td {
  padding: var(--xds-spacing-b)
}

._3QqVmB p {
  text-align: justify
}

@-webkit-keyframes Qn6GO8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes Qn6GO8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1zkLrW {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1zkLrW {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes rBmboI {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes rBmboI {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2Qj9uH {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2Qj9uH {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.BQbCF0 {
  border-top: var(--xds-border-regular) var(--xds-color-border-default);
  margin-bottom: calc(var(--xds-spacing-b)*-1);
  padding-top: var(--xds-spacing-d)
}

._3Ba4hU {
  padding-bottom: var(--xds-spacing-d)
}

@-webkit-keyframes zeBiXz {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes zeBiXz {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3-_mNn {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3-_mNn {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2qz90p {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2qz90p {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2eJMAW {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2eJMAW {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1IbQjL {
  background-color: var(--xds-color-support-brand-01);
  display: -webkit-box;
  display: flex;
  max-height: 100%;
  position: relative
}

@media screen and (min-width: 320px) {
  ._1IbQjL {
    height: 300px;
    margin-top: 0
  }
}

@media screen and (min-width: 721px) {
  ._1IbQjL {
    height: 520px;
    margin-top: 0
  }
}

@media screen and (min-width: 1025px) {
  ._1IbQjL {
    height: 570px
  }
}

@media screen and (min-width: 1281px) {
  ._1IbQjL {
    height: 630px
  }
}

@media screen and (min-width: 1441px) {
  ._1IbQjL {
    height: 709px
  }
}

._1IbQjL figure {
  align-self: center
}

@media screen and (min-width: 320px) {
  ._1IbQjL figure {
    height: 240px;
    margin: 0 auto;
    top: 3%;
    width: 270px
  }
}

@media screen and (min-width: 721px) {
  ._1IbQjL figure {
    height: 400px;
    top: 3%;
    width: 460px
  }
}

@media screen and (min-width: 1025px) {
  ._1IbQjL figure {
    height: 400px;
    left: 2%;
    top: -2%;
    width: 440px
  }
}

@media screen and (min-width: 1281px) {
  ._1IbQjL figure {
    height: 464px;
    width: 500px
  }
}

@media screen and (min-width: 1441px) {
  ._1IbQjL figure {
    height: 510px;
    width: 562px
  }
}

._1IbQjL img {
  width: auto;
  z-index: 9
}

@-webkit-keyframes _2afTpg {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2afTpg {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2NhvBs {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2NhvBs {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1CqQn3 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1CqQn3 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1hfIkh {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1hfIkh {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1W7fGa {
  background-color: var(--xds-color-support-brand-01);
  min-height: 100%;
  position: relative
}

._36EHw5 {
  left: -1px;
  position: absolute;
  top: -1px
}

@media screen and (min-width: 320px) {
  ._36EHw5 {
    height: 11.8vw;
    text-align: center;
    width: 100%
  }
}

@media screen and (min-width: 1025px) {
  ._36EHw5 {
    height: 100%;
    width: 6.8rem
  }
}

@media screen and (min-width: 1281px) {
  ._36EHw5 {
    width: 7.5rem
  }
}

@media screen and (min-width: 1441px) {
  ._36EHw5 {
    width: 8.5rem
  }
}

._36EHw5 .XboOIa {
  fill: var(--xds-color-background-subtle)
}

@-webkit-keyframes _1VJYUn {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1VJYUn {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1pTs_c {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1pTs_c {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2GZ6aO {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2GZ6aO {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _11Kt1O {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _11Kt1O {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2O6BUj {
  background-color: var(--xds-color-background-subtle)
}

._1fAtMp {
  margin: 0 auto
}

@media screen and (min-width: 320px) {
  ._39G1du {
    margin-top: calc(var(--xds-spacing-g) + var(--xds-spacing-b));
    padding-left: var(--xds-spacing-e);
    padding-right: var(--xds-spacing-e)
  }
}

@media screen and (min-width: 1025px) {
  ._39G1du {
    padding-left: var(--xds-spacing-g);
    padding-right: var(--xds-spacing-g)
  }
}

@media screen and (min-width: 1281px) {
  ._39G1du {
    padding-left: var(--xds-spacing-i);
    padding-right: var(--xds-spacing-i)
  }
}

@media screen and (min-width: 1441px) {
  ._39G1du {
    padding-left: calc(var(--xds-spacing-j) + var(--xds-spacing-j));
    padding-right: calc(var(--xds-spacing-g) + var(--xds-spacing-h))
  }
}

@-webkit-keyframes Hwl9DI {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes Hwl9DI {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3Nn8pI {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3Nn8pI {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1RgMwC {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1RgMwC {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _35tFt7 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _35tFt7 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@media screen and (min-width: 1025px) {
  ._1hprqE+._1hprqE {
    margin-left: var(--xds-spacing-e)
  }
}

@media screen and (min-width: 0) and (max-width:1024px) {
  ._1hprqE {
    margin: 0 var(--xds-spacing-e) var(--xds-spacing-e) var(--xds-spacing-e)
  }
}

._3Sx_97 {
  height: 20.5rem;
  padding: var(--xds-spacing-b)
}

._7Ixp-t {
  margin: 0 auto;
  width: 18.5rem
}

._27Bg12 {
  color: var(--xds-color-content-brand);
  font-size: var(--xds-font-size-32);
  font-weight: var(--xds-font-weight-extrabold);
  line-height: var(--xds-font-size-32-line-height);
  margin-top: var(--xds-spacing-b);
  text-align: center
}

@media screen and (min-width: 1025px) {
  ._27Bg12 {
    font-size: var(--xds-font-size-48);
    line-height: var(--xds-font-size-48-line-height)
  }
}

._3cgkmg svg {
  height: calc(var(--xds-font-size-32)*2);
  width: calc(var(--xds-font-size-32)*2)
}

@-webkit-keyframes _3rn3wW {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3rn3wW {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes mVFLxG {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes mVFLxG {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _104uk_ {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _104uk_ {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2EN8nZ {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2EN8nZ {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1ZU6l- {
  height: 67px;
  margin-bottom: var(--xds-spacing-d);
  position: relative
}

@-webkit-keyframes _17DRur {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _17DRur {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3XvOsu {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3XvOsu {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1SkxUr {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1SkxUr {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1NlYGv {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1NlYGv {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1_sm28 {
  margin: 0 auto;
  width: 20rem
}

@media screen and (min-width: 1025px) {
  ._1_sm28 {
    margin: 0 var(--xds-spacing-d)
  }
}

@-webkit-keyframes _3jIJjX {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3jIJjX {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1rIlF3 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1rIlF3 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _30F4Zr {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _30F4Zr {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3RKfAF {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3RKfAF {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.vEI0Do+.vEI0Do {
  margin-top: var(--xds-spacing-d)
}

@-webkit-keyframes OM6yd0 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes OM6yd0 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _27a6wl {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _27a6wl {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2lkpP4 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2lkpP4 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2gXqAb {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2gXqAb {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._31ITUL {
  margin-top: calc(var(--xds-spacing-a)*-1)
}

._39OVzS {
  margin: 0 calc(var(--xds-spacing-e)*-1)
}

._3rfWqe {
  height: calc(var(--xds-spacing-e)*2);
  margin: var(--xds-spacing-d) 0 calc(var(--xds-spacing-d)*2);
  position: relative
}

@-webkit-keyframes _2Y04Gk {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2Y04Gk {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2hH_DA {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2hH_DA {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3Zg3nv {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3Zg3nv {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _39F84W {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _39F84W {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3U4iJT {
  list-style: none;
  padding: 0
}

.KN3pXr+.KN3pXr,
.OSYBMh+.OSYBMh {
  margin-top: var(--xds-spacing-d)
}

@-webkit-keyframes gTWHB3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes gTWHB3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3QBJwO {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3QBJwO {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3uNCx_ {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3uNCx_ {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes prn6ng {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes prn6ng {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2WTs_X {
  margin-left: calc(var(--xds-spacing-d)*-1)
}

@-webkit-keyframes _3kUgT_ {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3kUgT_ {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2KJ5kd {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2KJ5kd {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2o7nAT {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2o7nAT {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1usEqo {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1usEqo {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._13GZxZ {
  position: relative
}

._2Wyyr0,
._13GZxZ {
  height: 100%;
  width: 100%
}

._2Wyyr0 {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  display: -webkit-box;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto
}

@-webkit-keyframes _3bqOwM {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3bqOwM {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1qb8Np {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1qb8Np {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _10MRN2 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _10MRN2 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes BfYkLi {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes BfYkLi {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1gy3GJ {
  margin: 0 auto;
  max-width: 1080px;
  width: 100%
}

._1gy3GJ._3q3Ccq {
  max-width: 960px
}

@-webkit-keyframes _2uJyTd {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2uJyTd {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1ZrOac {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1ZrOac {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2TsWS3 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2TsWS3 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2lGovy {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2lGovy {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2aB0pd {
  clip: rect(1px, 1px, 1px, 1px);
  -webkit-clip-path: inset(1px);
  clip-path: inset(1px);
  display: block;
  display: unset;
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px
}

.ejFApZ {
  margin-left: calc(var(--xds-spacing-d)*-1);
  margin-right: calc(var(--xds-spacing-d)*-1)
}

._3aoJ0M {
  color: var(--xds-color-content-default)
}

@-webkit-keyframes _2A3DyR {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2A3DyR {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1WGB8r {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1WGB8r {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1dt9NA {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1dt9NA {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes nK73iO {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes nK73iO {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.fd2pHm+.fd2pHm {
  margin-top: var(--xds-spacing-e)
}

@-webkit-keyframes _2rv0JS {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2rv0JS {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes -i3MN0 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes -i3MN0 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes C2Pz34 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes C2Pz34 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _27_qIo {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _27_qIo {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3ypACX {
  background-color: var(--xds-color-support-warning-02);
  border-bottom: 1px solid var(--xds-color-border-default);
  border-top: 1px solid var(--xds-color-border-default);
  margin-top: var(--xds-spacing-e);
  padding: var(--xds-spacing-e)
}

@-webkit-keyframes _2uyo2R {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2uyo2R {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _5mUA3h {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _5mUA3h {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3mQ4u5 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3mQ4u5 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2Kvjiv {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2Kvjiv {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.FHdH9c {
  height: 24px;
  position: relative;
  width: 24px
}

.CJrFsW {
  -webkit-box-pack: center;
  display: -webkit-box;
  display: flex;
  height: 32px;
  justify-content: center;
  margin-right: var(--xds-spacing-b);
  width: 32px
}

._10g7k- {
  -webkit-box-align: center;
  align-items: center
}

._244RPa {
  align-self: center
}

@-webkit-keyframes _1TZ1Mz {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1TZ1Mz {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2Bi1l8 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2Bi1l8 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _24p2HI {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _24p2HI {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _207jYP {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _207jYP {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1p2xJK {
  line-height: var(--xds-font-heading-s-line-height--wide);
  max-width: calc(100vw - 120px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap
}

@-webkit-keyframes _1PNiQE {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1PNiQE {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3ArBIb {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3ArBIb {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _16Sf6e {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _16Sf6e {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _24jIem {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _24jIem {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1lLGtb svg {
  color: var(--xds-color-content-default)
}

._1lLGtb [role=button]:focus {
  border-color: var(--xds-color-content-default)
}

@media screen and (min-width: 721px) {
  ._1lLGtb [role=button]:hover {
    border-color: var(--xds-color-content-default)
  }
}

@-webkit-keyframes _2cM94q {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2cM94q {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes GsgoYh {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes GsgoYh {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3hSGO7 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3hSGO7 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3MGCZg {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3MGCZg {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.RJBYQQ {
  --map-height: 450px;
  --title-height: 147px;
  --white-space: 78px;
  margin: calc(var(--xds-spacing-d)*-1) calc(var(--xds-spacing-d)*-1) 0;
  position: relative
}

@media screen and (min-width: 570px) and (max-width:1004px) {
  .RJBYQQ {
    --map-height: 400px
  }
}

@media screen and (min-width: 0) and (max-width:570px) {
  .RJBYQQ {
    --map-height: 50vh
  }
}

.RJBYQQ h1 {
  background-color: var(--xds-color-background-default);
  color: var(--xds-color-content-default);
  font-family: JETSansDigital, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: var(--xds-font-heading-l-size--narrow);
  font-weight: var(--xds-font-heading-l-weight);
  line-height: var(--xds-font-heading-l-line-height--narrow)
}

@media screen and (min-width: 570px) {
  .RJBYQQ h1 {
    font-size: var(--xds-font-heading-l-size--wide);
    line-height: var(--xds-font-heading-l-line-height--wide)
  }
}

.RJBYQQ p {
  color: var(--xds-color-content-default);
  font-family: JETSansDigital, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: var(--xds-font-body-l-size);
  font-weight: var(--xds-font-body-l-weight);
  line-height: var(--xds-font-body-l-line-height)
}

._25KZM7 {
  min-height: calc(var(--map-height) + var(--title-height));
  width: 100%
}

._25KZM7:before {
  background-color: #f5f6f9;
  background-image: url(/consumer-web/images/map-tile-background.svg);
  background-repeat: repeat;
  content: " ";
  display: block;
  min-height: var(--map-height);
  position: absolute;
  width: 100%;
  z-index: 0
}

.zydyOk {
  display: inline-block;
  right: var(--xds-spacing-d);
  top: calc(var(--map-height) - var(--xds-spacing-f)*1.5);
  z-index: 10
}

.uNIAmZ,
.zydyOk {
  position: absolute
}

.uNIAmZ {
  left: 50%;
  margin-top: var(--xds-spacing-i);
  padding-bottom: var(--xds-spacing-g);
  top: var(--map-height);
  -webkit-transform: translate(-50%);
  transform: translate(-50%)
}

@media screen and (min-width: 570px) {
  .uNIAmZ {
    padding-bottom: var(--xds-spacing-a)
  }
}

.Hfz-8A {
  -webkit-animation: _12zc4i 1s;
  animation: _12zc4i 1s;
  -webkit-animation-delay: 3s;
  animation-delay: 3s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  height: calc(var(--map-height) + var(--title-height) + 10px);
  position: relative;
  width: 100%;
  z-index: 0
}

@-webkit-keyframes _12zc4i {
  0% {
    background-color: transparent
  }

  to {
    background-color: var(--xds-color-background-default)
  }
}

@keyframes _12zc4i {
  0% {
    background-color: transparent
  }

  to {
    background-color: var(--xds-color-background-default)
  }
}

@media only screen and (max-width: 600px) {
  .zydyOk {
    top: var(--xds-spacing-d)
  }
}

.tkwy-food-tracker-dialog {
  margin-top: var(--xds-spacing-f);
  z-index: calc(1 + var(--z-index-header)) !important
}

@-webkit-keyframes _2Akhg2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2Akhg2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _38xjaE {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _38xjaE {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes hxApUk {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes hxApUk {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _90XRi6 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _90XRi6 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.r0gERZ {
  margin: auto
}

@media screen and (min-width: 720px) {
  .r0gERZ {
    max-width: 39.75rem
  }
}

._2ees7K {
  margin: 0 auto;
  max-width: 1280px;
  width: 100%
}

@-webkit-keyframes _3swDtO {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3swDtO {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3WbhVX {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3WbhVX {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3ewtCx {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3ewtCx {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1-D_aZ {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1-D_aZ {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.Kva3Bl {
  margin-top: calc(var(--xds-spacing-d)*-1)
}

._3-OKP5 {
  width: 80px
}

@-webkit-keyframes zXOzmt {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes zXOzmt {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3A9U6x {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3A9U6x {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3W_ndb {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3W_ndb {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2E9GXz {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2E9GXz {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1EO8Bt {
  display: inline-block;
  max-width: var(--xds-mq-s-max)
}

@-webkit-keyframes _3zEDOT {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3zEDOT {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1eIsso {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1eIsso {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2obyus {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2obyus {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes ghezsr {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes ghezsr {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2qqTJE {
  -webkit-box-pack: justify;
  -webkit-box-align: center;
  align-items: center;
  color: var(--xds-color-content-default);
  display: -webkit-box;
  display: flex;
  justify-content: space-between;
  padding: var(--xds-spacing-d);
  padding-bottom: 0
}

._2qqTJE.cdgC0f {
  padding: 0
}

@media screen and (min-width: 1025px) {
  ._2qqTJE.cdgC0f {
    -webkit-box-pack: start;
    justify-content: flex-start
  }
}

._3g6su5 {
  font-size: var(--xds-font-body-l-size);
  margin-right: var(--xds-spacing-e)
}

._1L3-Df {
  margin-left: auto
}

@-webkit-keyframes _3Mxkdn {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3Mxkdn {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1O_BB8 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1O_BB8 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2YNxrT {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2YNxrT {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3bgSsL {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3bgSsL {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.wgaSqM+.wgaSqM {
  margin-top: var(--xds-spacing-f)
}

@-webkit-keyframes DfmBTV {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes DfmBTV {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3EYETU {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3EYETU {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes wEy8ut {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes wEy8ut {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1ckoh1 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1ckoh1 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@media screen and (min-width: 0) and (max-width:1024px) {
  ._3vHkj5 {
    background: var(--xds-color-container-default);
    z-index: var(--z-index-modal)
  }
}

._1EMcgC,
.zDQuFL {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  display: -webkit-box;
  display: flex;
  flex-direction: column;
  height: 100%
}

@media screen and (min-width: 721px) and (max-width:1024px) {
  .zDQuFL {
    margin-left: auto;
    margin-right: auto;
    max-width: 568px;
    position: relative
  }
}

@media screen and (min-width: 1025px) {
  .zDQuFL {
    margin: 0;
    max-width: 100%
  }
}

@media screen and (min-width: 0) and (max-width:1025px) {
  ._2DtVR_ {
    overflow-y: auto
  }
}

._2iK3wN {
  background-color: var(--xds-color-background-subtle);
  padding: var(--xds-spacing-d)
}

@media screen and (min-width: 1025px) {
  ._2iK3wN {
    border: var(--xds-border-width-regular) solid var(--xds-color-border-default);
    border-color: var(--xds-color-border-subtle);
    border-radius: var(--xds-radius-rounded-a);
    padding: var(--xds-spacing-e)
  }
}

@-webkit-keyframes _2i56gU {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2i56gU {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3ef9fL {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3ef9fL {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3-Jkrm {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3-Jkrm {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2Anru1 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2Anru1 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.fQUuPu>div {
  background-color: var(--xds-color-container-subtle)
}

@-webkit-keyframes _2TWSo_ {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2TWSo_ {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes UCILqX {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes UCILqX {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3EATVo {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3EATVo {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1-s_bC {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1-s_bC {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1srNJY {
  padding: var(--xds-spacing-d) var(--xds-spacing-d) var(--xds-spacing-b)
}

._1lwehX {
  -webkit-box-pack: center;
  display: -webkit-box;
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  padding: var(--xds-spacing-e) var(--xds-spacing-d) 0
}

._2dumLc {
  border-top: none;
  -webkit-box-shadow: 0 -1px 1px -1px var(--xds-color-border-strong);
  box-shadow: 0 -1px 1px -1px var(--xds-color-border-strong);
  padding: var(--xds-spacing-d)
}

.XJHHwg {
  background: var(--xds-color-container-default);
  height: 100%;
  position: fixed;
  right: 0;
  top: 0;
  width: inherit;
  z-index: 1
}

@-webkit-keyframes _2uar6Z {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2uar6Z {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1a5S3g {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1a5S3g {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes LsbPbV {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes LsbPbV {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1fBrYQ {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1fBrYQ {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3Ivl2O {
  font-size: var(--xds-font-body-l-size);
  margin-bottom: var(--xds-spacing-d)
}

._3Ivl2O+._3Ivl2O {
  margin-top: var(--xds-spacing-b)
}

._1aKejh {
  left: 0;
  position: absolute;
  top: 0
}

._1HXkIq {
  color: var(--xds-color-content-default);
  margin-right: var(--xds-spacing-b)
}

._1IC5KW {
  margin-left: auto
}

._2ogrZV {
  display: inherit;
  margin-right: var(--xds-spacing-a)
}

._1Kq17N {
  color: var(--xds-color-content-subdued);
  display: -webkit-box;
  display: flex
}

.Hyv0Bp {
  background-color: var(--xds-color-support-info-02);
  border-radius: var(--xds-radius-rounded-b);
  display: inline-block;
  padding: var(--xds-spacing-a)
}

._1Kq17N,
.x7xyYf {
  font-size: var(--xds-font-body-s-size);
  margin-top: var(--xds-spacing-c);
  min-width: 168px;
  overflow-wrap: break-word;
  width: calc(100% - var(--xds-spacing-g)*2 - var(--xds-spacing-d) - var(--xds-spacing-b))
}

@-webkit-keyframes Ep3mPD {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes Ep3mPD {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3ifsE- {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3ifsE- {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1F8Whf {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1F8Whf {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3M3iu_ {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3M3iu_ {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2PKMHK+._2PKMHK {
  border-top: var(--xds-border-regular) var(--xds-color-divider-default);
  padding-top: var(--xds-spacing-d)
}

@-webkit-keyframes ZgglBp {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes ZgglBp {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1PetUL {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1PetUL {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1fsuxm {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1fsuxm {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2Q_P2q {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2Q_P2q {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._MSN-C {
  color: var(--xds-color-content-default);
  width: 100%
}

.BR8vdg {
  font-size: var(--xds-font-body-l-size);
  padding-bottom: var(--xds-spacing-d);
  width: 100%
}

._38usW_+._38usW_ {
  margin-top: var(--xds-spacing-a)
}

._3SCDp6 {
  clip: rect(1px, 1px, 1px, 1px);
  -webkit-clip-path: inset(1px);
  clip-path: inset(1px);
  display: block;
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px
}

@-webkit-keyframes _1RVXIv {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1RVXIv {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2aeNy3 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2aeNy3 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1CVpuE {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1CVpuE {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2K4-Jr {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2K4-Jr {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1mMiuq {
  position: relative
}

._1mMiuq+._1mMiuq {
  margin-top: var(--xds-spacing-b)
}

._1TSzDl {
  background: var(--xds-color-container-default);
  border: var(--xds-border-regular) var(--xds-color-border-strong);
  border-radius: var(--xds-radius-rounded-c);
  font-size: var(--xds-font-body-s-size);
  overflow: hidden;
  padding: var(--xds-spacing-c);
  pointer-events: none;
  position: relative
}

._1gDFci {
  background: var(--xds-color-container-strong)
}

._1gDFci,
._1gDFci * {
  color: var(--xds-color-content-disabled)
}

._3aUe66 {
  background: transparent;
  cursor: pointer;
  height: 100%;
  left: 0;
  opacity: 0;
  pointer-events: all;
  position: absolute;
  top: 0;
  width: 100%
}

._1X0NfA {
  -webkit-box-pack: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  display: -webkit-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: var(--xds-spacing-a);
  min-height: calc(var(--xds-font-body-s-size)*1.7*2)
}

@media screen and (min-width: 1025px) {
  ._1X0NfA {
    margin-left: var(--xds-spacing-a)
  }
}

.ApgvbB {
  -webkit-box-align: center;
  align-items: center;
  color: var(--xds-color-content-default);
  display: -webkit-box;
  display: flex;
  font-size: var(--xds-font-body-s-size);
  height: calc(var(--xds-font-body-s-size)*1.7*2);
  line-height: 1.7
}

._1t9Vtx {
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  display: -webkit-box;
  -webkit-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
  overflow: hidden;
  text-overflow: ellipsis
}

@media screen and (min-width: 1025px) {
  ._1XabKd {
    padding: var(--xds-spacing-a) var(--xds-spacing-c)
  }
}

@-webkit-keyframes _1wVZ-u {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1wVZ-u {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes KKfyOl {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes KKfyOl {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1n4V-1 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1n4V-1 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _273cJt {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _273cJt {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3O6SkA {
  font-size: .86rem;
  word-break: break-all
}

@-webkit-keyframes _2veirO {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2veirO {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1ji8Qq {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1ji8Qq {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3avwKt {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3avwKt {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3s_zAe {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3s_zAe {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@media screen and (min-width: 721px) {
  .r4GUaz {
    border: 1px dotted;
    margin-bottom: var(--xds-spacing-d);
    padding: var(--xds-spacing-d)
  }
}

._1ckqdB {
  padding: var(--xds-spacing-d)
}

@-webkit-keyframes i6llZC {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes i6llZC {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3pddz2 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3pddz2 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes zp5uPH {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes zp5uPH {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes MvfYGS {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes MvfYGS {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3M-0Ho {
  padding: 0 var(--xds-spacing-d) var(--xds-spacing-b) var(--xds-spacing-d)
}

._3Q43zE {
  padding: 0 0 var(--xds-spacing-c)
}

._3h-iM4 {
  text-transform: uppercase
}

._22lRqw {
  color: var(--xds-color-content-default)
}

@-webkit-keyframes _3W3nQ_ {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3W3nQ_ {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2W8ww_ {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2W8ww_ {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1hxZX0 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1hxZX0 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes j66Km9 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes j66Km9 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.Rxfr3y {
  margin: calc(var(--xds-spacing-a)*-1)
}

._2WZL6U {
  margin-bottom: var(--xds-spacing-c);
  width: calc(100%/var(--xds-spacing-b))
}

._2XY-_W {
  height: var(--xds-spacing-f)
}

._1A8KW3 {
  margin-bottom: var(--xds-spacing-b)
}

@-webkit-keyframes _2hTwWY {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2hTwWY {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes zhM5gM {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes zhM5gM {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _14TR-f {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _14TR-f {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1VHTwe {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1VHTwe {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@media screen and (min-width: 721px) and (max-width:1440px) {
  ._3W733K {
    padding: var(--xds-spacing-e) 0
  }
}

@media screen and (min-width: 1025px) {
  ._1VEyXg {
    margin: var(--xds-spacing-e) 0
  }

  ._2quztN {
    margin-bottom: var(--xds-spacing-d);
    max-width: 568px;
    width: 60%
  }
}

@-webkit-keyframes _2vS7y0 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2vS7y0 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3hDop7 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3hDop7 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2MME1E {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2MME1E {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes qnHmWh {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes qnHmWh {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.DsjZsb {
  -webkit-box-flex: 0;
  flex: 0
}

@-webkit-keyframes _1ycVHQ {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1ycVHQ {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1cFi7c {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1cFi7c {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1FRck_ {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1FRck_ {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _30xS2_ {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _30xS2_ {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2PEIgo {
  text-align: center
}

@media screen and (min-width: 721px) {
  ._2PEIgo {
    width: 66%
  }
}

@media screen and (min-width: 1025px) {
  ._2PEIgo {
    width: 50%
  }
}

@media screen and (min-width: 1281px) {
  ._2PEIgo {
    width: 33%
  }
}

._2jA5jX {
  height: calc(var(--xds-spacing-b)*6);
  margin-bottom: var(--xds-spacing-b);
  position: relative
}

@-webkit-keyframes _1-c2GQ {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1-c2GQ {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _26b2gX {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _26b2gX {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2x4GJE {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2x4GJE {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1k3thq {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1k3thq {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._21_6wW {
  color: var(--xds-color-content-link-distinct);
  text-decoration: underline
}

@-webkit-keyframes IGN45R {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes IGN45R {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2Yw7CJ {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2Yw7CJ {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _32quVw {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _32quVw {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3IdmDi {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3IdmDi {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3dpuXs {
  font-size: var(--xds-font-body-l-size)
}

._3dpuXs+._3dpuXs {
  margin-top: var(--xds-spacing-b)
}

._2ZtF7s {
  margin-bottom: var(--xds-spacing-d)
}

._2ZtF7s+._2ZtF7s {
  margin-top: var(--xds-spacing-d)
}

._1jm6vk,
._2qpkuc {
  margin-top: var(--xds-spacing-b);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none
}

._2qpkuc {
  font-size: var(--xds-font-size-16)
}

._1No0cq {
  left: 0;
  position: absolute;
  top: 0
}

.Cu32pm {
  margin-right: var(--xds-spacing-b)
}

._39OXJT,
.Cu32pm {
  color: var(--xds-color-content-default)
}

._39OXJT {
  margin-left: 0
}

._1j376Y {
  margin-left: auto
}

._2i9AUn {
  display: inherit
}

._2FvLhN,
._2i9AUn {
  margin-right: var(--xds-spacing-a)
}

._2sDX-- {
  margin-left: auto;
  margin-right: 1px
}

._1PbtZx {
  color: var(--xds-color-content-subdued)
}

._20e9mQ {
  background-color: var(--xds-color-support-info-02);
  border-radius: var(--xds-radius-rounded-b);
  display: inline-block;
  padding: var(--xds-spacing-a)
}

._1PbtZx,
._2VqMea {
  font-size: var(--xds-font-body-s-size);
  margin-top: var(--xds-spacing-c);
  min-width: 168px;
  overflow-wrap: break-word;
  width: calc(100% - var(--xds-spacing-g)*2 - var(--xds-spacing-d) - var(--xds-spacing-b))
}

.j07lLF {
  clip: rect(1px, 1px, 1px, 1px);
  -webkit-clip-path: inset(1px);
  clip-path: inset(1px);
  display: block;
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px
}

@-webkit-keyframes _1JFhN7 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1JFhN7 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3tQOUi {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3tQOUi {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2l5UiM {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2l5UiM {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2wfsPq {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2wfsPq {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3vUmwK {
  display: inline-block;
  padding-top: var(--xds-spacing-a);
  vertical-align: text-top
}

@-webkit-keyframes oVxq72 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes oVxq72 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes qjkiOw {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes qjkiOw {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3rrup_ {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3rrup_ {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _13Ce_P {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _13Ce_P {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2iWI5r+._2iWI5r {
  border-top: var(--xds-border-regular) var(--xds-color-divider-default);
  padding-top: var(--xds-spacing-d)
}

@-webkit-keyframes _3F7pVt {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3F7pVt {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2h6G8F {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2h6G8F {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3cBERe {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3cBERe {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _10oKmn {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _10oKmn {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3thAdG {
  color: var(--xds-color-content-default);
  width: 100%
}

.Qi471o {
  font-size: var(--xds-font-body-l-size);
  padding-bottom: var(--xds-spacing-d);
  width: 100%
}

._2gGddd+._2gGddd {
  margin-top: var(--xds-spacing-a)
}

._28WhUA {
  clip: rect(1px, 1px, 1px, 1px);
  -webkit-clip-path: inset(1px);
  clip-path: inset(1px);
  display: block;
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px
}

@-webkit-keyframes _1hn3Hm {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1hn3Hm {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3t2K4E {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3t2K4E {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes O-7HKM {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes O-7HKM {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1mQAyY {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1mQAyY {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3uADPO {
  padding-bottom: var(--xds-spacing-b)
}

@-webkit-keyframes _3Up93i {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3Up93i {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3MYeD- {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3MYeD- {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes HO3i1_ {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes HO3i1_ {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes Hldq_F {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes Hldq_F {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.s9_Grk+.s9_Grk {
  margin-top: var(--xds-spacing-b)
}

@-webkit-keyframes _3yJHWZ {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3yJHWZ {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes AVMsBi {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes AVMsBi {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1TYqLZ {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1TYqLZ {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2OShHC {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2OShHC {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.OQlbDh {
  padding: var(--xds-spacing-d) var(--xds-spacing-d) var(--xds-spacing-b)
}

@-webkit-keyframes wfTJ2e {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes wfTJ2e {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _4Dav5J {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _4Dav5J {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _6XxvNM {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _6XxvNM {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1_nXvT {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1_nXvT {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2XOghU {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap
}

@-webkit-keyframes _3F_Keq {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3F_Keq {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2__Np- {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2__Np- {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1IuEDr {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1IuEDr {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2gpxoJ {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2gpxoJ {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2GShOf,
._2Nhxs3 {
  -webkit-box-align: center;
  align-content: center;
  align-items: center;
  display: -webkit-box;
  display: flex;
  position: absolute;
  top: auto;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  z-index: 1
}

._2GShOf {
  background: -webkit-gradient(linear, left top, right top, color-stop(80%, #fff), to(hsla(0, 0%, 100%, 0)));
  background: linear-gradient(90deg, #fff 80%, hsla(0, 0%, 100%, 0));
  left: -16px;
  width: 64px
}

._2GShOf,
._2Nhxs3 {
  -webkit-box-pack: center;
  height: 120px;
  justify-content: center
}

._2Nhxs3 {
  background: -webkit-gradient(linear, right top, left top, color-stop(80%, #fff), to(hsla(0, 0%, 100%, 0)));
  background: linear-gradient(270deg, #fff 80%, hsla(0, 0%, 100%, 0));
  right: -8px;
  width: 48px
}

.T-emeo {
  -webkit-box-align: center;
  align-items: center;
  display: -webkit-box;
  display: flex
}

._2EPa2R,
.T-emeo {
  position: relative;
  width: 100%
}

._2EPa2R {
  overflow: hidden;
  z-index: 0
}

._17a4k0 {
  list-style: none;
  margin-bottom: 0;
  margin-top: 0;
  width: 100%
}

._10ap5C ._17a4k0 {
  margin-left: calc(var(--xds-spacing-e)*-1 + var(--xds-spacing-d)*-1)
}

@-webkit-keyframes _4uzcQ5 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _4uzcQ5 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1f_RGv {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1f_RGv {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3r0SLN {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3r0SLN {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3hsExV {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3hsExV {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1KPPrL {
  max-width: 264px
}

._1WvWPF {
  -webkit-box-align: center;
  align-items: center;
  display: -webkit-box;
  display: flex;
  gap: var(--xds-spacing-c)
}

._1WsgE9 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap
}

._2PLxj2 {
  margin-bottom: -8px;
  margin-right: -26px;
  margin-top: 4px
}

._3ZqHTk {
  -webkit-box-pack: center;
  -webkit-box-flex: 0;
  background-color: var(--xds-color-interactive-secondary);
  border-radius: var(--xds-radius-rounded-e);
  display: -webkit-inline-box;
  display: inline-flex;
  flex: 0 0 auto;
  height: 32px;
  justify-content: center;
  vertical-align: middle;
  width: 32px
}

._2rum9c,
._3ZqHTk {
  -webkit-box-align: center;
  align-items: center
}

._2rum9c {
  display: -webkit-box;
  display: flex
}

._2rum9c:not(:last-child):after {
  background-color: var(--xds-color-content-subdued);
  border-radius: var(--xds-radius-rounded-e);
  content: "";
  display: inline-block;
  height: calc(var(--xds-spacing-a)/2);
  margin: 0 var(--xds-spacing-a);
  width: calc(var(--xds-spacing-a)/2)
}

._3UIPIp,
.mXGWsG {
  display: -webkit-box;
  display: flex
}

.mXGWsG {
  -webkit-box-pack: justify;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  height: 80px;
  justify-content: space-between
}

@-webkit-keyframes _2DGlBV {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2DGlBV {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3ImrHr {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3ImrHr {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2fXb5L {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2fXb5L {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes QkoiMj {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes QkoiMj {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2xSYpE {
  padding-left: var(--xds-spacing-d);
  padding-right: var(--xds-spacing-d)
}

._2ba2kV {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap
}

@media screen and (min-width: 1025px) {
  ._2ba2kV {
    width: 180px
  }
}

@-webkit-keyframes _2lEC2q {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2lEC2q {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2Vhm9I {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2Vhm9I {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3KuWmI {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3KuWmI {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3daM9I {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3daM9I {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1oMnhU {
  background-color: var(--xds-color-support-brand-03);
  border-radius: var(--xds-radius-rounded-d);
  margin-left: var(--xds-spacing-d);
  margin-right: var(--xds-spacing-d);
  overflow: hidden;
  padding-bottom: var(--xds-spacing-d);
  padding-top: var(--xds-spacing-d)
}

@-webkit-keyframes BSnEWo {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes BSnEWo {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3VGO-F {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3VGO-F {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3D7kF0 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3D7kF0 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1wGMfW {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1wGMfW {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3dLleS {
  background: var(--xds-color-background-default);
  border-top: var(--xds-border-width-regular) solid var(--xds-color-border-default);
  bottom: 0;
  left: 0;
  padding: var(--xds-spacing-b);
  position: fixed;
  width: 100%;
  z-index: 1
}

@-webkit-keyframes _3H9FG8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3H9FG8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes N8QXPx {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes N8QXPx {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3Odoh8 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3Odoh8 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes BOWXRV {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes BOWXRV {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3MPC0r {
  display: -webkit-inline-box;
  display: inline-flex;
  position: relative
}

@-webkit-keyframes takVE3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes takVE3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes abfFcJ {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes abfFcJ {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3n6RAC {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3n6RAC {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2NkyLW {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2NkyLW {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2KiJW4 {
  margin: 0 auto;
  max-width: 31.5rem;
  min-width: 20rem;
  padding: var(--xds-spacing-b)
}

@-webkit-keyframes _2xXk6X {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2xXk6X {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1zCrvD {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1zCrvD {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2c_z46 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2c_z46 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes i8Fa8e {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes i8Fa8e {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._345izh {
  display: inline-block
}

@-webkit-keyframes _2hiflp {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2hiflp {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1hvIbV {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1hvIbV {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _25dwlQ {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _25dwlQ {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2WFX62 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2WFX62 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.PQfiFE {
  -webkit-box-align: center;
  align-items: center;
  display: contents
}

.PQfiFE:not(:last-child):after {
  background-color: var(--xds-color-content-subdued);
  border-radius: var(--xds-radius-rounded-e);
  content: "";
  display: inline-block;
  height: 2px;
  margin: 0 var(--xds-spacing-b) calc(var(--xds-spacing-a) - 2px);
  width: 2px
}

._3Kq1_o {
  margin-top: auto
}

.fzCwkd {
  background-color: var(--xds-color-container-subtle);
  height: 70px;
  width: 70px
}

@media screen and (min-width: 721px) {
  .fzCwkd {
    height: 170px;
    width: 170px
  }
}

._37dttc {
  font-size: var(--xds-font-heading-s-size--narrow);
  font-weight: 700;
  line-height: 1.7;
  text-align: center;
  width: var(--xds-spacing-f)
}

._26UJHu {
  color: var(--xds-color-content-disabled);
  padding-right: var(--xds-spacing-c);
  text-decoration: line-through
}

._2kNLhk {
  display: -webkit-inline-box;
  display: inline-flex;
  padding: 0 var(--xds-spacing-b) 0 var(--xds-spacing-a)
}

.pqFL95 {
  padding-top: var(--xds-spacing-b)
}

@media screen and (min-width: 0) and (max-width:720px) {
  ._2z-NHe:not(._1uuzr9) {
    margin-right: calc(var(--xds-font-body-s-size)*1.7*-1 + var(--xds-spacing-b)*3.2*-1 - var(--xds-spacing-b)*-1)
  }
}

@-webkit-keyframes _3ptYts {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3ptYts {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2qQIUc {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2qQIUc {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes QsMY0D {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes QsMY0D {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2BCR24 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2BCR24 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1oaef5 {
  text-decoration: line-through
}

._2lDSyB {
  margin-left: var(--xds-spacing-b)
}

@-webkit-keyframes _2LYlNo {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2LYlNo {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3OIWuD {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3OIWuD {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _34-LPs {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _34-LPs {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2rAgJV {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2rAgJV {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.JqUCth {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  display: -webkit-box;
  display: flex;
  flex-direction: column;
  width: 100%
}

@-webkit-keyframes _1hC3a5 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1hC3a5 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1mP3tQ {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1mP3tQ {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2Fg2g8 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2Fg2g8 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1ZMlcR {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1ZMlcR {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._9Ekcj_ {
  position: relative
}

._9Ekcj_+._9Ekcj_ {
  margin-top: var(--xds-spacing-b)
}

._2qRKiM {
  background: var(--xds-color-container-default);
  border: var(--xds-border-regular) var(--xds-color-border-strong);
  border-radius: var(--xds-radius-rounded-c);
  font-size: var(--xds-font-body-s-size);
  overflow: hidden;
  padding: var(--xds-spacing-c);
  pointer-events: none;
  position: relative
}

._3lqaEU {
  background: var(--xds-color-container-strong)
}

._3lqaEU,
._3lqaEU * {
  color: var(--xds-color-content-disabled)
}

._3C4YRh {
  background: transparent;
  cursor: pointer;
  height: 100%;
  left: 0;
  opacity: 0;
  pointer-events: all;
  position: absolute;
  top: 0;
  width: 100%
}

._1w9NA2 {
  -webkit-box-pack: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  display: -webkit-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: var(--xds-spacing-a);
  min-height: calc(var(--xds-font-body-s-size)*1.7*2)
}

@media screen and (min-width: 1025px) {
  ._1w9NA2 {
    margin-left: var(--xds-spacing-a)
  }
}

.wHwYC5 {
  -webkit-box-align: center;
  align-items: center;
  color: var(--xds-color-content-default);
  display: -webkit-box;
  display: flex;
  font-size: var(--xds-font-body-s-size);
  height: calc(var(--xds-font-body-s-size)*1.7*2);
  line-height: 1.7
}

._1krGeU {
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  display: -webkit-box;
  -webkit-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
  overflow: hidden;
  text-overflow: ellipsis
}

@media screen and (min-width: 1025px) {
  ._1rnDjL {
    padding: var(--xds-spacing-a) var(--xds-spacing-c)
  }
}

@-webkit-keyframes _3zBfNx {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3zBfNx {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _32ESC9 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _32ESC9 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3g3D6s {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3g3D6s {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2Kbbub {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2Kbbub {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1uKa01 {
  margin: calc(var(--xds-spacing-a)*-1)
}

._3OtQfA {
  margin-bottom: var(--xds-spacing-c);
  width: calc(100%/var(--xds-spacing-b))
}

._1IIXpD {
  height: var(--xds-spacing-f)
}

._2In9zQ {
  margin-bottom: var(--xds-spacing-b)
}

@-webkit-keyframes NCIy8C {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes NCIy8C {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _21WCwP {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _21WCwP {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2j3zV8 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2j3zV8 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3-zZ9v {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3-zZ9v {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2NF-E6 {
  font-size: .86rem;
  word-break: break-all
}

@-webkit-keyframes _2uWJK {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2uWJK {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1Et9zy {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1Et9zy {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3d8V3x {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3d8V3x {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1Y73Xw {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1Y73Xw {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.L6YzXq {
  opacity: .38;
  pointer-events: none
}

@-webkit-keyframes _2J2QuD {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2J2QuD {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes u5-kII {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes u5-kII {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2s-vt1 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2s-vt1 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3d5RJr {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3d5RJr {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2-7FJu {
  -webkit-box-flex: 0;
  flex: 0
}

@-webkit-keyframes _3pJ1Oj {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3pJ1Oj {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes Y_BbZT {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes Y_BbZT {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1oJufJ {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1oJufJ {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes N-Y3pW {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes N-Y3pW {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@media screen and (min-width: 721px) {
  ._1xw8dN {
    border: 1px dotted;
    margin-bottom: var(--xds-spacing-d);
    padding: var(--xds-spacing-d)
  }
}

._3ITg3F {
  padding: var(--xds-spacing-d)
}

@-webkit-keyframes vkr3xX {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes vkr3xX {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3UYOVV {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3UYOVV {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2pKJ5K {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2pKJ5K {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1tMQAo {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1tMQAo {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2Zm_1b {
  margin: calc(var(--xds-spacing-d)*-1) calc(var(--xds-spacing-d)*-1) 0 calc(var(--xds-spacing-d)*-1)
}

._2Zm_1b,
._2zNDx5 {
  background-color: var(--xds-color-support-brand-02);
  border-bottom: var(--xds-border-width-regular) solid var(--xds-color-border-subtle);
  font-size: var(--xds-font-caption-size);
  padding: var(--xds-spacing-b) var(--xds-spacing-d)
}

._2zNDx5 {
  margin: calc(var(--xds-spacing-d)*-1)
}

@-webkit-keyframes _2HhItU {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2HhItU {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1RDw9g {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1RDw9g {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2nK8P5 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2nK8P5 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2dZYZU {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2dZYZU {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2FOtbP {
  border-top: 1px solid var(--xds-color-border-subtle);
  padding: var(--xds-spacing-d)
}

._2FOtbP._2w_UYJ {
  border-top: none;
  padding: var(--xds-spacing-d) 0
}

._2FOtbP._3aaKs- {
  padding: 0 0 var(--xds-spacing-d) 0
}

@-webkit-keyframes DQ85JI {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes DQ85JI {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes -iyYLO {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes -iyYLO {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _14RS4H {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _14RS4H {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes fTXb9O {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes fTXb9O {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2kkmCU {
  padding: 0 var(--xds-spacing-d) var(--xds-spacing-b) var(--xds-spacing-d)
}

.VPR5fR {
  padding: 0 0 var(--xds-spacing-c)
}

._1AZgtl {
  text-transform: uppercase
}

.Ef1AVx {
  color: var(--xds-color-content-default)
}

@-webkit-keyframes _3B3RmV {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3B3RmV {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _359dEJ {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _359dEJ {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _4jqz6W {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _4jqz6W {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3FGy-r {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3FGy-r {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2bjmSa {
  position: relative
}

@media screen and (min-width: 1025px) {
  ._2bjmSa:after {
    background: var(--xds-color-background-default);
    bottom: 0;
    content: "";
    height: 1px;
    left: 0;
    position: absolute;
    right: 0;
    z-index: 1
  }
}

._2-6w3o {
  margin: 0 var(--xds-spacing-d) var(--xds-spacing-d)
}

@media screen and (min-width: 0) and (max-width:1024px) {
  ._2-6w3o {
    position: relative
  }
}

@-webkit-keyframes _2mzBPY {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2mzBPY {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2mBk8e {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2mBk8e {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes B1GAvm {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes B1GAvm {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1HZZbb {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1HZZbb {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._39NOMq {
  background: var(--xds-color-background-default);
  height: 100%;
  width: 100%
}

@-webkit-keyframes _2sQ3g- {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2sQ3g- {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2vyW7P {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2vyW7P {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3vIj55 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3vIj55 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2QT11H {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2QT11H {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._39wVRr+._39wVRr {
  margin-top: var(--xds-spacing-b)
}

@-webkit-keyframes _3cODDS {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3cODDS {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3nzYur {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3nzYur {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3fDBM9 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3fDBM9 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _8TWFUo {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _8TWFUo {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2XG3z6+._2XG3z6 {
  margin-top: var(--xds-spacing-b)
}

@-webkit-keyframes _2bu3oD {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2bu3oD {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2PZVdw {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2PZVdw {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _156Isn {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _156Isn {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _5JJGbp {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _5JJGbp {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2A-aUS {
  margin-top: var(--xds-spacing-e)
}

._2A-aUS button+button {
  margin-top: var(--xds-spacing-b)
}

@-webkit-keyframes _14-KmT {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _14-KmT {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3fNNGH {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3fNNGH {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _13NIQP {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _13NIQP {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1dl7eK {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1dl7eK {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2blI8O {
  background-color: var(--xds-color-container-dark);
  margin: calc(var(--xds-spacing-d)*-1) calc(var(--xds-spacing-d)*-1) 0 calc(var(--xds-spacing-d)*-1)
}

._1kB1uC {
  height: 5px;
  margin: 0 auto;
  max-width: 960px;
  width: 100%
}

._1HnGcN {
  position: relative;
  -webkit-transform: translateY(-80%);
  transform: translateY(-80%)
}

._3Yie9j {
  left: 100%;
  position: absolute;
  top: 40%;
  -webkit-transform: translate(-100%, -100%);
  transform: translate(-100%, -100%)
}

@media screen and (min-width: 720px) {
  ._3Yie9j {
    top: 25%
  }
}

._1xgdD0 {
  margin-right: var(--xds-spacing-b)
}

@media screen and (min-width: 721px) {
  ._1xgdD0 {
    margin-right: 0;
    padding-right: var(--xds-spacing-e)
  }

  ._3FZwaS {
    margin-bottom: calc(var(--xds-spacing-d)*-1)
  }
}

._1pD3H4 {
  -webkit-box-align: center;
  -webkit-box-pack: center;
  align-items: center;
  display: -webkit-box;
  display: flex;
  height: var(--xds-icon-size-02);
  justify-content: center;
  width: var(--xds-icon-size-02)
}

._1pD3H4>* {
  display: -webkit-box !important;
  display: flex !important;
  width: 100%
}

._1ifkTx {
  display: -webkit-box;
  display: flex;
  font-size: var(--xds-font-size-14);
  margin-top: var(--xds-spacing-d)
}

@media screen and (min-width: 721px) {
  ._1ifkTx {
    width: calc(50% - var(--xds-spacing-b)*8)
  }
}

._2YIdLB {
  margin-top: var(--xds-spacing-d)
}

@media screen and (min-width: 0) and (max-width:720px) {
  ._2YIdLB {
    font-size: var(--xds-font-caption-size)
  }
}

._258LqS {
  max-width: 568px
}

._2P_0d_ {
  padding: 0 var(--xds-spacing-d);
  position: relative
}

@-webkit-keyframes _2rCYAt {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2rCYAt {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1l4IZc {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1l4IZc {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3O6Oin {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3O6Oin {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes R5HlNI {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes R5HlNI {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1GVNvG:not(:last-child) {
  -webkit-box-align: center;
  align-items: center;
  display: -webkit-box;
  display: flex
}

._1GVNvG:not(:last-child):after {
  background-color: var(--xds-color-content-subdued);
  border-radius: var(--xds-radius-rounded-e);
  content: "";
  display: inline-block;
  height: var(--xds-spacing-a);
  margin: 0 var(--xds-spacing-b);
  width: var(--xds-spacing-a)
}

@-webkit-keyframes cLEeBV {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes cLEeBV {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes Mv1XuI {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes Mv1XuI {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes lEWFRn {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes lEWFRn {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes myUdOT {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes myUdOT {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._13kI_t {
  margin-top: var(--xds-spacing-c)
}

._1J0hOn,
._1RYziv {
  -webkit-box-align: center;
  align-content: center;
  align-items: center;
  background: var(--xds-color-content-light);
  border-radius: var(--xds-radius-rounded-e);
  -webkit-box-shadow: var(--xds-elevation-05);
  box-shadow: var(--xds-elevation-05);
  color: var(--xds-color-content-brand);
  display: -webkit-box;
  display: flex;
  height: calc(var(--xds-spacing-e) + var(--xds-spacing-d));
  position: absolute;
  top: auto;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: calc(var(--xds-spacing-e) + var(--xds-spacing-d));
  z-index: 1
}

._1J0hOn {
  left: 5px;
  margin-right: 5px
}

._1J0hOn,
._1RYziv {
  -webkit-box-pack: center;
  justify-content: center
}

._1RYziv {
  margin-left: 5px;
  right: 5px
}

._3L-Woc {
  -webkit-box-align: center;
  align-items: center;
  display: -webkit-box;
  display: flex;
  position: relative;
  width: calc(100% - var(--xds-spacing-e))
}

@media screen and (min-width: 721px) {
  ._3L-Woc {
    overflow: hidden;
    width: 100%
  }
}

._1xgcIE {
  overflow: hidden;
  position: relative;
  width: 100%;
  z-index: 0
}

._1xgcIE .swiper-container {
  overflow: visible
}

@media screen and (min-width: 721px) {
  ._1LFe21 {
    margin: 0 calc(var(--xds-spacing-e) + var(--xds-spacing-d))
  }
}

._2RYumG,
._33t1fM {
  list-style: none;
  margin-bottom: 0;
  margin-top: 0;
  padding: var(--xds-spacing-d) 0 0;
  width: 100%
}

._33t1fM {
  height: calc(var(--xds-spacing-b)*17)
}

._2RYumG {
  height: calc(var(--xds-spacing-b)*13)
}

@media screen and (min-width: 721px) {

  ._3x0R_x ._33t1fM,
  .WnU2BX ._2RYumG {
    margin-left: calc(var(--xds-spacing-e)*-1 + var(--xds-spacing-d)*-1)
  }
}

._3nfEK5,
._13oUgt {
  width: calc(100% + var(--xds-spacing-d))
}

@media screen and (min-width: 721px) {

  ._3nfEK5,
  ._13oUgt {
    width: 100%
  }
}

@media screen and (min-width: 1281px) {

  ._3nfEK5 ._1LFe21,
  ._3nfEK5 ._33t1fM,
  ._13oUgt ._1LFe21,
  ._13oUgt ._2RYumG {
    margin: 0
  }
}

@-webkit-keyframes _3FoKTs {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3FoKTs {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes rV_LfR {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes rV_LfR {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2e_kpn {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2e_kpn {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3uoiOF {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3uoiOF {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._8x9TrG {
  height: auto
}

._8x9TrG._2RGMqL,
._8x9TrG._29CszR {
  width: 291px
}

._8x9TrG._29CszR {
  height: 50px
}

._8x9TrG._2RGMqL {
  height: 85px
}

._8x9TrG+._8x9TrG {
  margin-top: var(--xds-spacing-d)
}

._2KwuP9 {
  color: var(--xds-color-content-subdued);
  font-size: var(--xds-font-caption-size);
  padding: var(--xds-spacing-a) 0 var(--xds-spacing-c)
}

._2KwuP9._2RGMqL {
  bottom: 0;
  position: absolute
}

._1cQ7CZ {
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis
}

.dNs4Jk {
  background-color: var(--xds-color-yellow);
  height: calc(100% + var(--sds-card-padding-small)*2);
  left: calc(var(--sds-card-padding-small)*-1);
  top: calc(var(--sds-card-padding-small)*-1);
  width: calc(100% + var(--sds-card-padding-small)*2)
}

.dNs4Jk,
.wBc6-j {
  position: absolute
}

.wBc6-j {
  height: 200px;
  right: -100px;
  top: -20px;
  width: 200px
}

@-webkit-keyframes _1UiG0d {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1UiG0d {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3eLa9q {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3eLa9q {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3fruTJ {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3fruTJ {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3Yjkwy {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3Yjkwy {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1vKs86 {
  -webkit-box-align: center;
  align-items: center;
  display: -webkit-box;
  display: flex;
  position: relative;
  width: calc(100% - var(--xds-spacing-e))
}

@media screen and (min-width: 721px) {
  ._1vKs86 {
    overflow: hidden;
    width: 100%
  }
}

.repYDZ,
.ZmSwTe {
  -webkit-box-align: center;
  align-content: center;
  align-items: center;
  display: -webkit-box;
  display: flex;
  height: 100%;
  position: absolute;
  top: 0;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: calc(var(--xds-spacing-f) + var(--xds-spacing-c));
  z-index: 1
}

.repYDZ {
  -webkit-box-pack: start;
  background: -webkit-gradient(linear, left top, right top, color-stop(80%, var(xds-color-background-subtle)), to(hsla(0, 0%, 100%, 0)));
  background: linear-gradient(90deg, var(xds-color-background-subtle) 80%, hsla(0, 0%, 100%, 0) 100%);
  justify-content: flex-start;
  left: 0
}

.repYDZ._1Ouy4z {
  background: -webkit-gradient(linear, left top, right top, color-stop(80%, var(--xds-color-container-default)), to(hsla(0, 0%, 100%, 0)));
  background: linear-gradient(90deg, var(--xds-color-container-default) 80%, hsla(0, 0%, 100%, 0) 100%)
}

.ZmSwTe {
  -webkit-box-pack: end;
  background: -webkit-gradient(linear, right top, left top, color-stop(80%, var(xds-color-background-subtle)), to(hsla(0, 0%, 100%, 0)));
  background: linear-gradient(-90deg, var(xds-color-background-subtle) 80%, hsla(0, 0%, 100%, 0) 100%);
  justify-content: flex-end;
  right: 0
}

.ZmSwTe._1Ouy4z {
  background: -webkit-gradient(linear, right top, left top, color-stop(80%, var(--xds-color-container-default)), to(hsla(0, 0%, 100%, 0)));
  background: linear-gradient(-90deg, var(--xds-color-container-default) 80%, hsla(0, 0%, 100%, 0) 100%)
}

._3YmQOx {
  overflow: hidden;
  position: relative;
  width: 100%;
  z-index: 0
}

._3YmQOx .swiper-container {
  overflow: visible
}

._3YmQOx._26aO18,
._3YmQOx._39h3i0 {
  width: calc(100% - var(--xds-spacing-f) - var(--xds-spacing-c))
}

._3YmQOx._39h3i0 {
  margin-left: calc(var(--xds-spacing-f) + var(--xds-spacing-c))
}

._3YmQOx._3ZSgyg {
  width: calc(100% - var(--xds-spacing-f)*2 - var(--xds-spacing-c)*2)
}

@media screen and (min-width: 721px) {
  ._36hAT2 {
    margin: 0 calc(var(--xds-spacing-f) + var(--xds-spacing-c))
  }
}

._2O6EQ8 {
  height: calc(var(--xds-spacing-b)*7);
  padding: calc(var(--xds-spacing-a)*3) 0;
  width: 100%
}

._2O6EQ8._2OYA23 {
  height: calc(var(--xds-spacing-b)*6);
  padding: calc(var(--xds-spacing-a)*2) 0
}

@media screen and (min-width: 721px) {
  ._1MZv-F ._2O6EQ8 {
    margin-left: calc(var(--xds-spacing-f)*-1 + var(--xds-spacing-c)*-1)
  }
}

._3ToYMV {
  width: calc(100% + var(--xds-spacing-d))
}

@media screen and (min-width: 721px) {
  ._3ToYMV {
    width: 100%
  }
}

@media screen and (min-width: 1281px) {

  ._3ToYMV ._2O6EQ8,
  ._3ToYMV ._36hAT2 {
    margin: 0
  }
}

@-webkit-keyframes _1up2El {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1up2El {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1EAEBd {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1EAEBd {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2XPTHX {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2XPTHX {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes VX9X3b {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes VX9X3b {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2qhbof {
  width: calc(90% - var(--xds-spacing-g))
}

@media screen and (min-width: 721px) {
  ._2qhbof {
    width: calc(100% - var(--xds-spacing-g)*2)
  }
}

@-webkit-keyframes _2CSFv- {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2CSFv- {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _20mzPr {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _20mzPr {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3WJHFX {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3WJHFX {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _21d-Sp {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _21d-Sp {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3x5PqJ {
  margin: 0 calc(var(--xds-spacing-d)*-1) var(--xds-spacing-b) calc(var(--xds-spacing-d)*-1)
}

._1jyWP_,
._3x5PqJ {
  padding: 0 var(--xds-spacing-d)
}

._1jyWP_ {
  -webkit-box-align: center;
  align-items: center;
  background-color: var(--xds-color-container-default);
  display: -webkit-box;
  display: flex;
  height: var(--xds-spacing-h)
}

.vU-GOc ._1jyWP_ {
  height: 92px;
  padding-bottom: var(--xds-spacing-d);
  padding-top: var(--xds-spacing-b)
}

@-webkit-keyframes _1u-Tb6 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1u-Tb6 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes dnTZ7M {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes dnTZ7M {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2V-LyA {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2V-LyA {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2NdgGK {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2NdgGK {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1PEZoi {
  color: var(--xds-color-content-default);
  display: -webkit-inline-box;
  display: inline-flex;
  height: var(--xds-icon-size-04);
  line-height: var(--xds-font-size-20-line-height);
  margin-left: var(--xds-spacing-a);
  margin-right: var(--xds-spacing-a);
  padding-left: 2px;
  vertical-align: top
}

._3CeGYz {
  vertical-align: middle
}

._3CeGYz svg {
  vertical-align: inherit
}

@-webkit-keyframes kSgHFm {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes kSgHFm {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3ZZeSQ {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3ZZeSQ {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3a-BiK {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3a-BiK {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3pwqWJ {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3pwqWJ {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2gMVoE {
  margin: var(--xds-spacing-a) 0
}

._2Dnb58 {
  margin-left: 8px
}

@-webkit-keyframes qQAND_ {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes qQAND_ {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _32anck {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _32anck {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _8VdLmI {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _8VdLmI {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes rlYIFa {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes rlYIFa {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2n2oEz {
  background-color: var(--xds-color-support-warning);
  border-radius: 8px;
  display: -webkit-inline-box;
  display: inline-flex;
  height: 24px;
  vertical-align: baseline
}

@media screen and (min-width: 0) and (max-width:720px) {
  ._2n2oEz {
    border-radius: 4px;
    height: 16px
  }
}

._3tfBaz {
  display: -webkit-inline-box;
  display: inline-flex;
  padding: 2px 4px;
  vertical-align: bottom
}

@media screen and (min-width: 0) and (max-width:720px) {
  ._3tfBaz {
    padding: 0 4px
  }
}

@-webkit-keyframes _ZMTf0 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _ZMTf0 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1elxro {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1elxro {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _9Iq7Ye {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _9Iq7Ye {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1x2yug {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1x2yug {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2uYQC- {
  margin-top: var(--xds-spacing-d)
}

@-webkit-keyframes _2zAsk6 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2zAsk6 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2cyDXo {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2cyDXo {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1BIRyC {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1BIRyC {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1BdMj1 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1BdMj1 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3hLchg {
  list-style: none;
  margin: 0;
  padding: 0
}

._3hLchg.xyhhTY {
  padding-bottom: calc(var(--xds-spacing-b) + var(--xds-spacing-f))
}

._2TWTUN+._2TWTUN {
  margin-top: var(--xds-spacing-d)
}

@-webkit-keyframes _3zZMRX {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3zZMRX {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3AwHeU {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3AwHeU {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes j8NxpF {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes j8NxpF {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes DZSQVI {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes DZSQVI {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2-ueMg+._2-ueMg {
  padding-top: var(--xds-spacing-f)
}

._1mBr8U {
  border-radius: calc(var(--sds-card-radius) + 1px);
  overflow: hidden
}

.KLWLgc {
  height: 5.5rem
}

@media screen and (min-width: 721px) {
  .KLWLgc {
    height: 9.5rem
  }
}

._2KqyZV {
  background-color: var(--xds-color-container-strong);
  height: 5.5rem
}

@media screen and (min-width: 721px) {
  ._2KqyZV {
    height: 9.5rem
  }
}

._59qHtS {
  margin-right: var(--xds-spacing-a);
  position: relative;
  top: .2ex
}

._2QfyxH {
  margin: calc(var(--xds-spacing-d)*-1) calc(var(--xds-spacing-d)*-1) var(--xds-spacing-d) calc(var(--xds-spacing-d)*-1)
}

@-webkit-keyframes _5u45EW {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _5u45EW {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _19vUXw {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _19vUXw {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2vy9gV {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2vy9gV {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2p_IEt {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2p_IEt {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@-webkit-keyframes _1fPVsx {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1fPVsx {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3-DE8w {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3-DE8w {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes SpMxwx {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes SpMxwx {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes oN5GwS {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes oN5GwS {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.GcAXtd {
  color: var(--xds-color-content-subdued);
  font-size: var(--xds-font-body-l-size);
  line-height: var(--xds-font-body-l-line-height)
}

.GcAXtd+.GcAXtd {
  margin-top: var(--xds-spacing-d)
}

@-webkit-keyframes _3xElam {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3xElam {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1S3O1E {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1S3O1E {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes TMCdF- {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes TMCdF- {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1DctW- {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1DctW- {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1biGZ3 {
  margin-right: var(--xds-spacing-c)
}

._32ZtIu {
  -webkit-box-align: center;
  align-items: center;
  display: -webkit-box;
  display: flex;
  margin-bottom: var(--xds-spacing-b)
}

._2AyYT2 {
  background-color: var(--xds-color-background-default);
  padding: 0 var(--xds-spacing-d) var(--xds-spacing-e)
}

@-webkit-keyframes _2-rjQS {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2-rjQS {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2VhtP9 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2VhtP9 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1sqhdk {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1sqhdk {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2rc7OZ {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2rc7OZ {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@media screen and (min-width: 0) and (max-width:1024px) {
  ._1DM8oy {
    background: var(--xds-color-container-default);
    bottom: 0;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: var(--z-index-modal)
  }
}

._1hheOc,
._35HZi- {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  display: -webkit-box;
  display: flex;
  flex-direction: column;
  height: 100%
}

@media screen and (min-width: 721px) and (max-width:1024px) {
  ._1hheOc {
    margin-left: auto;
    margin-right: auto;
    max-width: 568px;
    padding-top: var(--xds-spacing-d);
    position: relative
  }
}

@media screen and (min-width: 1025px) {
  ._1hheOc {
    margin: 0;
    max-width: 100%;
    padding-left: var(--xds-spacing-d);
    padding-right: var(--xds-spacing-d)
  }
}

@media screen and (min-width: 0) and (max-width:721px) {
  ._1hheOc {
    padding-top: var(--xds-spacing-d)
  }
}

@media screen and (min-width: 0) and (max-width:1025px) {
  ._31bQY5 {
    overflow-y: auto
  }
}

._5Mrl6 {
  background: var(--xds-color-container-default);
  padding: var(--xds-spacing-d) var(--xds-spacing-e)
}

@media screen and (min-width: 1025px) {
  ._5Mrl6 {
    border: 1px solid var(--xds-color-border-strong);
    border-radius: var(--xds-radius-rounded-c);
    padding-top: var(--xds-spacing-d)
  }

  ._3kZshc {
    margin-bottom: var(--xds-spacing-d);
    max-width: 568px;
    width: 60%
  }

  .wZAqqs {
    margin: var(--xds-spacing-e) 0
  }
}

@media screen and (min-width: 0) and (max-width:1025px) {
  .wZAqqs {
    margin-bottom: var(--xds-spacing-d);
    padding-left: var(--xds-spacing-e);
    padding-right: var(--xds-spacing-e)
  }
}

@media screen and (min-width: 0) and (max-width:721px) {
  .wZAqqs {
    margin-bottom: var(--xds-spacing-d)
  }
}

._1l_-tT {
  margin-bottom: var(--xds-spacing-d)
}

@media screen and (min-width: 0) and (max-width:1024px) {
  ._1l_-tT {
    position: relative
  }
}

@-webkit-keyframes _2K36TA {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2K36TA {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _227rTc {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _227rTc {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2HMTos {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2HMTos {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes lrr-5n {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes lrr-5n {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3jkAPp {
  margin: 0 auto;
  width: 50%
}

.JNOUQt {
  display: -webkit-box;
  display: flex;
  width: 100%
}

._3p5L1y {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column
}

@-webkit-keyframes _2iFNbA {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2iFNbA {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3FDTdR {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3FDTdR {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3-D129 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3-D129 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1HdoNH {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1HdoNH {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1PzSWP {
  color: var(--xds-color-content-subdued);
  font-size: var(--xds-font-size-14);
  padding: var(--xds-spacing-b) 0 0
}

._3nGlJX {
  margin-bottom: var(--xds-spacing-c);
  margin-left: var(--xds-spacing-b)
}

._2nkFI8 {
  word-break: break-all
}

@-webkit-keyframes _3lD4ym {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3lD4ym {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes WqVD6k {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes WqVD6k {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2G6Ia1 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2G6Ia1 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes Ey0sd0 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes Ey0sd0 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._38XcSW {
  -webkit-box-align: center;
  align-items: center;
  display: -webkit-box;
  display: flex
}

._38XcSW:not(:last-child):after {
  background-color: var(--xds-color-content-subdued);
  border-radius: var(--xds-radius-rounded-e);
  content: "";
  display: inline-block;
  height: calc(var(--xds-spacing-a)/2);
  margin: 0 var(--xds-spacing-a);
  width: calc(var(--xds-spacing-a)/2)
}

@-webkit-keyframes _23Dyrw {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _23Dyrw {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _4oQbAW {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _4oQbAW {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes WebqtE {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes WebqtE {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _-6jeQV {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _-6jeQV {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2Nqdf9 {
  display: inline-block
}

._2n_9-E {
  word-break: break-all
}

@-webkit-keyframes _1LokTi {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1LokTi {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2BJi36 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2BJi36 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1CkKDa {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1CkKDa {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1j_G2U {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1j_G2U {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3sdEMc {
  display: -webkit-inline-box;
  display: inline-flex;
  min-height: var(--xds-icon-size-03)
}

._3sdEMc,
._9kJSFt {
  -webkit-box-align: center;
  align-items: center
}

._9kJSFt {
  -webkit-box-pack: center;
  background-color: transparent;
  border: var(--xds-border-regular) var(--xds-color-interactive-form);
  border-radius: var(--xds-radius-rounded-e);
  color: var(--xds-color-interactive-form);
  cursor: pointer;
  display: -webkit-box;
  display: flex;
  height: 24px;
  justify-content: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 24px
}

@media screen and (min-width: 721px) {
  ._9kJSFt:hover {
    background-color: var(--xds-color-transparent--hover-01)
  }
}

._9kJSFt:active {
  background-color: var(--xds-color-transparent--active-01)
}

._9kJSFt:disabled {
  background-color: var(--xds-color-container-strong);
  border-color: transparent;
  cursor: default;
  pointer-events: none
}

._9kJSFt svg {
  height: 12px;
  width: 12px
}

._2Mn9cI {
  -webkit-box-align: center;
  -webkit-box-pack: center;
  align-items: center;
  background-color: var(--xds-color-interactive-brand);
  border-radius: var(--xds-radius-rounded-e);
  color: var(--xds-color-content-inverse);
  display: -webkit-box;
  display: flex;
  font-size: 19px;
  font-weight: var(--xds-font-weight-bold);
  height: var(--xds-icon-size-03);
  justify-content: center;
  line-height: var(--xds-font-size-16-line-height);
  margin: 0 var(--xds-spacing-a);
  min-width: var(--xds-icon-size-03);
  padding: 0 3px
}

._3Fq3n6 ._2Mn9cI {
  min-width: 30px
}

@-webkit-keyframes _1HQknC {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1HQknC {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes MmmMf6 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes MmmMf6 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes gL9hWL {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes gL9hWL {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2g15tB {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2g15tB {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3g9C8g {
  cursor: pointer;
  word-break: break-all
}

._3bE2pK {
  cursor: default
}

@-webkit-keyframes _2wp6Sr {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2wp6Sr {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes rNfbir {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes rNfbir {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2ggRIm {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2ggRIm {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3T7aEi {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3T7aEi {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2I5NbB {
  margin-bottom: var(--xds-spacing-b);
  min-width: 100px
}

@-webkit-keyframes nmcjbO {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes nmcjbO {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes ufpH7c {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes ufpH7c {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1_fwil {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1_fwil {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3Vi2Kh {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3Vi2Kh {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1Fhkb2 {
  margin: 0 var(--xds-spacing-e);
  max-width: 568px
}

@media screen and (min-width: 0) and (max-width:1024px) {
  ._1Fhkb2 {
    margin: 0 var(--xds-spacing-d)
  }
}

@-webkit-keyframes _33rTTE {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _33rTTE {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _33IlmY {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _33IlmY {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _8MJiyU {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _8MJiyU {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1owRJG {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1owRJG {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.u1jH_p {
  width: 100%
}

@media screen and (min-width: 1024px) {
  .u1jH_p {
    margin-bottom: -8px;
    margin-top: -8px
  }
}

@media screen and (min-width: 0) and (max-width:1024px) {
  .u1jH_p {
    padding-left: 8px;
    padding-right: 8px
  }
}

@-webkit-keyframes YTbVn8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes YTbVn8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1VXePl {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1VXePl {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1pCVJd {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1pCVJd {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _51EWRg {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _51EWRg {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.ZgtRCO {
  margin: 0 var(--xds-spacing-e) var(--xds-spacing-e);
  max-width: 568px
}

@media screen and (min-width: 0) and (max-width:1024px) {
  .ZgtRCO {
    margin: 0 var(--xds-spacing-d) var(--xds-spacing-e)
  }
}

.ZgtRCO._39ewAN {
  max-width: none
}

._1MshO0 {
  margin: 0 calc(var(--xds-spacing-e)*-1) var(--xds-spacing-d)
}

@media screen and (min-width: 0) and (max-width:1024px) {
  ._1MshO0 {
    margin: 0 calc(var(--xds-spacing-d)*-1) var(--xds-spacing-d)
  }
}

._1MshO0 img {
  height: auto;
  width: 100%
}

._1MshO0 figure {
  margin: 0 auto
}

._119fvc {
  background-color: var(--xds-color-white);
  border-radius: var(--xds-radius-rounded-e);
  position: absolute;
  right: calc(var(--xds-spacing-a) + var(--xds-spacing-d));
  top: var(--xds-spacing-d);
  z-index: 10
}

@-webkit-keyframes _3Bn-S8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3Bn-S8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2oYJS0 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2oYJS0 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1TMbaV {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1TMbaV {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3gf-nx {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3gf-nx {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1Hq-8t {
  -webkit-box-align: center;
  align-items: center;
  display: -webkit-box;
  display: flex
}

._1Hq-8t:not(:last-child):after {
  background-color: var(--xds-color-content-subdued);
  border-radius: var(--xds-radius-rounded-e);
  content: "";
  display: inline-block;
  height: var(--xds-spacing-a);
  margin: 0 var(--xds-spacing-b);
  width: var(--xds-spacing-a)
}

@-webkit-keyframes CODSfu {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes CODSfu {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _13om6Z {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _13om6Z {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2gT6VA {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2gT6VA {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1zZf38 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1zZf38 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2skEse {
  padding: 0 var(--xds-spacing-a);
  width: 100%
}

.ut1QWb {
  -webkit-box-shadow: var(--xds-elevation-03);
  box-shadow: var(--xds-elevation-03);
  z-index: 1
}

._12xU2L {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap
}

@-webkit-keyframes ktjR1n {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes ktjR1n {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes zTez-A {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes zTez-A {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2zFjI- {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2zFjI- {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3L7MEk {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3L7MEk {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2rTX_v {
  display: block
}

._1U7b5T {
  display: none
}

@-webkit-keyframes _3mknwP {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3mknwP {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2AJwbf {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2AJwbf {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3GBPpw {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3GBPpw {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes hSZt9D {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes hSZt9D {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3GnGyo {
  -webkit-box-shadow: 0 8px 8px -2px rgba(27, 35, 36, .08);
  box-shadow: 0 8px 8px -2px rgba(27, 35, 36, .08);
  position: relative
}

@-webkit-keyframes _3iFWae {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3iFWae {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _364fBW {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3pCbQ- {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3pCbQ- {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1mYT-T {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1mYT-T {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._9w-0cG {
  background-color: var(--xds-color-background-subtle);
  overflow: hidden;
  position: relative
}

._9w-0cG:after {
  -webkit-animation: _364fBW 1s infinite;
  animation: _364fBW 1s infinite;
  background-image: -webkit-gradient(linear, left top, right top, color-stop(0, hsla(0, 0%, 100%, 0)), color-stop(20%, hsla(0, 0%, 100%, .2)), color-stop(60%, hsla(0, 0%, 100%, .5)), to(hsla(0, 0%, 100%, 0)));
  background-image: linear-gradient(90deg, hsla(0, 0%, 100%, 0), hsla(0, 0%, 100%, .2) 20%, hsla(0, 0%, 100%, .5) 60%, hsla(0, 0%, 100%, 0));
  bottom: 0;
  content: "";
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%)
}

@keyframes _364fBW {
  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

._195YRY+._195YRY {
  margin-top: var(--xds-spacing-d)
}

._3uDbRX {
  border-radius: var(--xds-radius-rounded-a);
  height: var(--xds-spacing-e);
  margin-bottom: var(--xds-spacing-d);
  width: 150px
}

@media screen and (min-width: 721px) {
  ._3uDbRX {
    width: 340px
  }
}

._3zvzay {
  height: var(--xds-spacing-b);
  margin-bottom: calc(var(--xds-spacing-a)*9);
  max-width: 80%;
  width: 150px
}

._2UcIvP {
  height: var(--xds-spacing-e);
  margin-top: auto;
  max-width: 100%;
  width: 80px
}

._2woOHa {
  -webkit-box-direction: normal;
  flex-direction: column;
  padding-right: var(--xds-spacing-d)
}

._2woOHa,
.bM2d1B {
  -webkit-box-orient: vertical;
  display: -webkit-box;
  display: flex
}

.bM2d1B {
  -webkit-box-direction: reverse;
  flex-direction: column-reverse;
  margin-left: auto
}

@media screen and (min-width: 721px) {
  .bM2d1B {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    flex-direction: row
  }
}

._3LZIAp {
  background-color: var(--xds-color-background-subtle);
  height: 64px;
  width: 64px
}

@media screen and (min-width: 721px) {
  ._3LZIAp {
    height: 112px;
    width: 112px
  }
}

._1Llis7 {
  background-color: var(--xds-color-background-subtle);
  border-radius: 50%;
  height: 48px;
  margin-bottom: var(--xds-spacing-b);
  width: 48px
}

@media screen and (min-width: 721px) {
  ._1Llis7 {
    margin-left: var(--xds-spacing-f)
  }
}

@-webkit-keyframes _2K_aZf {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2K_aZf {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1YhY1I {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1YhY1I {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes dXKToC {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes dXKToC {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3VTVSb {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3VTVSb {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2zjbIi {
  margin-left: auto;
  margin-right: auto;
  max-width: 960px
}

._1ZLKh1 {
  margin-bottom: var(--xds-spacing-e);
  width: 313px
}

@media screen and (min-width: 721px) {
  ._1ZLKh1 {
    width: 167px
  }
}

@-webkit-keyframes _1Ssu_x {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1Ssu_x {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _19MzlM {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _32zCRm {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _32zCRm {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3SmVMm {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3SmVMm {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1_SCsL {
  background-color: var(--xds-color-container-default);
  -webkit-box-shadow: 0 4px 6px rgba(27, 35, 36, .02), 0 2px 12px -2px rgba(27, 35, 36, .08), 0 3px 6px rgba(27, 35, 36, .06);
  box-shadow: 0 4px 6px rgba(27, 35, 36, .02), 0 2px 12px -2px rgba(27, 35, 36, .08), 0 3px 6px rgba(27, 35, 36, .06);
  margin-top: calc(var(--xds-spacing-d)*-1);
  padding: 0 var(--xds-spacing-d);
  position: relative
}

.drVhRy {
  height: 144px;
  margin-left: calc(var(--xds-spacing-d)*-1);
  margin-right: calc(var(--xds-spacing-d)*-1)
}

@media screen and (min-width: 721px) {
  .drVhRy {
    height: 320px
  }
}

._1udlcx {
  margin-bottom: var(--xds-spacing-d)
}

._1EHm8g {
  background-color: var(--xds-color-container-strong);
  border-radius: var(--xds-radius-rounded-a);
  height: 72px;
  position: absolute;
  -webkit-transform: translateY(-56px);
  transform: translateY(-56px);
  width: 72px
}

@media screen and (min-width: 721px) {
  ._1EHm8g {
    height: 80px;
    -webkit-transform: translateY(-64px);
    transform: translateY(-64px);
    width: 80px
  }
}

._3Mm_mH {
  margin-right: var(--xds-spacing-b)
}

@media screen and (min-width: 721px) {
  ._3Mm_mH {
    margin-right: 0;
    max-width: calc(50% - var(--xds-spacing-i));
    padding-right: var(--xds-spacing-e)
  }

  .lJ1aA2 {
    margin-left: auto
  }
}

._3iV66m {
  display: inline-block;
  height: 48px;
  width: 48px
}

._3iV66m+._3iV66m {
  margin-left: var(--xds-spacing-b)
}

._3GGPNS {
  max-width: 100%;
  width: 174px
}

@media screen and (min-width: 721px) {
  ._3GGPNS {
    margin-bottom: calc(var(--xds-spacing-a)*-1);
    width: 328px
  }
}

._2WWziZ {
  margin-bottom: var(--xds-spacing-a);
  margin-top: var(--xds-spacing-d);
  max-width: 100%;
  width: 85px
}

@media screen and (min-width: 721px) {
  ._2WWziZ {
    width: 185px
  }
}

._19MzlM {
  background-color: var(--xds-color-background-subtle);
  overflow: hidden;
  position: relative
}

._19MzlM:after {
  -webkit-animation: _19MzlM 1s infinite;
  animation: _19MzlM 1s infinite;
  background-image: -webkit-gradient(linear, left top, right top, color-stop(0, hsla(0, 0%, 100%, 0)), color-stop(20%, hsla(0, 0%, 100%, .2)), color-stop(60%, hsla(0, 0%, 100%, .5)), to(hsla(0, 0%, 100%, 0)));
  background-image: linear-gradient(90deg, hsla(0, 0%, 100%, 0), hsla(0, 0%, 100%, .2) 20%, hsla(0, 0%, 100%, .5) 60%, hsla(0, 0%, 100%, 0));
  bottom: 0;
  content: "";
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  -webkit-transform: translateX(-100%);
  transform: translateX(-100%)
}

@keyframes _19MzlM {
  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1gDCaw {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1gDCaw {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes MvjTec {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes MvjTec {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3Q8hyJ {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3Q8hyJ {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1zzX4R {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1zzX4R {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1YyWrt:not(:last-child) {
  -webkit-box-align: center;
  align-items: center;
  display: contents
}

._1YyWrt:not(:last-child):after {
  background-color: var(--xds-color-content-subdued);
  border-radius: var(--xds-radius-rounded-e);
  content: "";
  display: inline-block;
  height: 2px;
  margin: 0 var(--xds-spacing-a) 2px;
  width: 2px
}

._2AKtq9 {
  margin-top: auto
}

.rdzIVp {
  border-radius: var(--xds-radius-rounded-c);
  -webkit-box-shadow: var(--xds-elevation-02);
  box-shadow: var(--xds-elevation-02);
  height: 132px
}

._2w7HJg {
  width: 200px
}

._2swIsV {
  width: 328px
}

.xI0Gpr {
  font-size: var(--fz-h5);
  font-weight: 700;
  line-height: var(--lh-loose);
  text-align: center;
  width: var(--space-xl)
}

.hQF5JM {
  height: 16px;
  white-space: nowrap
}

._1ggn36,
.hQF5JM {
  -webkit-box-pack: start;
  justify-content: flex-start;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 144px
}

._1ggn36 {
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  height: 48px
}

._2O7oOK {
  font-weight: lighter;
  padding-right: var(--xds-spacing-c);
  text-decoration: line-through
}

._1mSOdV {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 144px
}

@-webkit-keyframes PLzIm3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes PLzIm3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2C88TI {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2C88TI {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1Wxslg {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1Wxslg {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3EEHE4 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3EEHE4 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@media screen and (min-width: 721px) {
  ._2jnQxY {
    margin-bottom: var(--xds-spacing-c);
    padding: 0 var(--xds-spacing-d);
    position: relative
  }
}

.FIa105 {
  background-color: var(--xds-color-background-subtle);
  padding: var(--xds-spacing-d) 0
}

@media screen and (min-width: 721px) {
  .FIa105 {
    border-radius: var(--xds-radius-rounded-c)
  }
}

._1BMXTT {
  font-weight: bolder
}

@media screen and (min-width: 0) and (max-width:721px) {
  ._1BMXTT {
    padding: 0 var(--xds-spacing-d)
  }
}

._1cCHNs,
._28-oZx {
  -webkit-box-align: center;
  align-content: center;
  align-items: center;
  background: var(--xds-color-content-light);
  border-radius: var(--xds-radius-rounded-e);
  -webkit-box-shadow: var(--xds-elevation-05);
  box-shadow: var(--xds-elevation-05);
  color: var(--xds-color-content-brand);
  display: -webkit-box;
  display: flex;
  height: calc(var(--xds-spacing-e) + var(--xds-spacing-d));
  position: absolute;
  top: auto;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: calc(var(--xds-spacing-e) + var(--xds-spacing-d));
  z-index: 1
}

._1cCHNs {
  left: 5px;
  margin-right: 5px
}

._1cCHNs,
._28-oZx {
  -webkit-box-pack: center;
  justify-content: center
}

._28-oZx {
  margin-left: 5px;
  right: 5px
}

._2ktQZT {
  -webkit-box-align: center;
  align-items: center;
  display: -webkit-box;
  display: flex;
  position: relative
}

@media screen and (min-width: 721px) {
  ._2ktQZT {
    overflow: hidden;
    width: 100%
  }
}

._1UdGiK {
  overflow: hidden;
  position: relative;
  width: 100%;
  z-index: 0
}

._1UdGiK .swiper-container {
  overflow: visible
}

.wFBuBZ {
  height: calc(var(--xds-spacing-b)*17);
  list-style: none;
  margin-bottom: 0;
  margin-top: 0;
  width: 100%
}

._1bmEpg .wFBuBZ {
  margin-left: calc(var(--xds-spacing-e)*-1 + var(--xds-spacing-d)*-1)
}

@media screen and (min-width: 721px) {
  ._3ygJFv {
    width: 100%
  }
}

@media screen and (min-width: 1281px) {
  ._3ygJFv ._1QdBrC {
    margin: 0
  }
}

@-webkit-keyframes _1Rf948 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1Rf948 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3_aXor {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3_aXor {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1YreLt {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1YreLt {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3FZBbY {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3FZBbY {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2CK2Zz {
  text-align: center
}

@media screen and (min-width: 721px) {
  ._2CK2Zz {
    width: 66%
  }
}

@media screen and (min-width: 1025px) {
  ._2CK2Zz {
    width: 50%
  }
}

@media screen and (min-width: 1281px) {
  ._2CK2Zz {
    width: 33%
  }
}

._2VOUvx {
  height: calc(var(--xds-spacing-b)*6);
  margin-bottom: var(--xds-spacing-b);
  position: relative
}

@-webkit-keyframes pbkxW7 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes pbkxW7 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes JecnAG {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes JecnAG {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2AFuBE {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2AFuBE {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes NmNdNT {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes NmNdNT {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3yoicb {
  padding-top: 0
}

@media screen and (min-width: 1281px) {
  ._3yoicb {
    padding-top: var(--xds-spacing-b)
  }
}

.Utlaih {
  min-width: 0;
  padding-left: 0
}

@-webkit-keyframes _31g4vQ {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _31g4vQ {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3VpYhM {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3VpYhM {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2-Mn4v {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2-Mn4v {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes ulcjF3 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes ulcjF3 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._58ICAe {
  background-color: var(--xds-color-container-subtle);
  border-radius: var(--xds-radius-rounded-e);
  font-weight: var(--xds-font-weight-extrabold);
  height: 32px;
  line-height: var(--xds-font-size-24-line-height);
  width: 32px
}

._19g7xX,
._58ICAe {
  display: inline-block;
  text-align: center
}

._19g7xX {
  padding: 2px 4px
}

@-webkit-keyframes _2r2V-p {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2r2V-p {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes RdhRzB {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes RdhRzB {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes RP2eCk {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes RP2eCk {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1gjXJh {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1gjXJh {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3FYevf {
  background-color: var(--xds-color-background-default);
  padding: var(--xds-spacing-d)
}

._2Rsgz2 {
  -webkit-column-gap: var(--xds-spacing-b);
  -moz-column-gap: var(--xds-spacing-b);
  column-gap: var(--xds-spacing-b);
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin-top: var(--xds-spacing-d);
  row-gap: var(--xds-spacing-d)
}

@media screen and (min-width: 721px) {
  ._2Rsgz2 {
    grid-template-columns: repeat(6, 1fr)
  }
}

@media screen and (min-width: 1025px) {
  ._2Rsgz2 {
    grid-template-columns: repeat(4, 1fr)
  }
}

@media screen and (min-width: 1281px) {
  ._2Rsgz2 {
    -webkit-column-gap: var(--xds-spacing-d);
    -moz-column-gap: var(--xds-spacing-d);
    column-gap: var(--xds-spacing-d);
    grid-template-columns: repeat(6, 1fr)
  }
}

._3AIn2v {
  min-width: 0
}

._3AIn2v>* {
  height: 100%
}

@-webkit-keyframes _2rF0_f {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2rF0_f {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _293Gi9 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _293Gi9 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2DLl5k {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2DLl5k {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1MhZ4x {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1MhZ4x {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._33mX_M {
  padding-left: var(--xds-spacing-d);
  padding-right: var(--xds-spacing-d);
  padding-top: var(--xds-spacing-d)
}

@media screen and (min-width: 1281px) {
  ._33mX_M {
    padding-left: 0
  }
}

@-webkit-keyframes _3RM8Gg {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3RM8Gg {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _5pz19O {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _5pz19O {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _4XLN5t {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _4XLN5t {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2KnwfM {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2KnwfM {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2QRlnu {
  display: block
}

._2kEzPX {
  display: none
}

@-webkit-keyframes c4nOiM {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes c4nOiM {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _33HtJj {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _33HtJj {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes iY-1MU {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes iY-1MU {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3L_zib {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3L_zib {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

html {
  scroll-behavior: auto
}

.B2BH_S {
  -webkit-box-align: center;
  align-items: center;
  display: -webkit-box;
  display: flex;
  position: relative;
  width: calc(100% + var(--xds-spacing-d))
}

@media screen and (min-width: 721px) {
  .B2BH_S {
    overflow: hidden;
    width: 100%
  }
}

@media screen and (min-width: 1281px) {

  .B2BH_S ._2WV0yZ,
  .B2BH_S .M_Zb3e {
    margin: 0
  }
}

._1vUJS6,
.fQRGI8 {
  -webkit-box-align: center;
  align-content: center;
  align-items: center;
  display: -webkit-box;
  display: flex;
  height: 100%;
  position: absolute;
  top: 0;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: calc(var(--xds-spacing-f) + var(--xds-spacing-c));
  z-index: 1
}

.fQRGI8 {
  -webkit-box-pack: start;
  background: -webkit-gradient(linear, left top, right top, color-stop(80%, var(--xds-color-container-default)), to(hsla(0, 0%, 100%, 0)));
  background: linear-gradient(90deg, var(--xds-color-container-default) 80%, hsla(0, 0%, 100%, 0) 100%);
  justify-content: flex-start;
  left: 0
}

._1vUJS6 {
  -webkit-box-pack: end;
  background: -webkit-gradient(linear, right top, left top, color-stop(80%, var(--xds-color-container-default)), to(hsla(0, 0%, 100%, 0)));
  background: linear-gradient(-90deg, var(--xds-color-container-default) 80%, hsla(0, 0%, 100%, 0) 100%);
  justify-content: flex-end;
  right: 0
}

.El6Hnd {
  overflow: hidden;
  position: relative;
  width: 100%;
  z-index: 0
}

.El6Hnd .swiper-container {
  overflow: visible
}

.El6Hnd._1M2oqU,
.El6Hnd._1T_4ES {
  width: calc(100% - var(--xds-spacing-f) - var(--xds-spacing-c))
}

.El6Hnd._1T_4ES {
  margin-left: calc(var(--xds-spacing-f) + var(--xds-spacing-c))
}

.El6Hnd._3JwnAm {
  width: calc(100% - var(--xds-spacing-f)*2 - var(--xds-spacing-c)*2)
}

@media screen and (min-width: 721px) {
  ._2WV0yZ {
    margin: 0 calc(var(--xds-spacing-f) + var(--xds-spacing-c))
  }
}

@media screen and (min-width: 1281px) {
  ._2WV0yZ {
    margin: 0
  }
}

.M_Zb3e {
  width: 100%
}

@media screen and (min-width: 1281px) {
  .M_Zb3e {
    margin: 0
  }
}

@media screen and (min-width: 721px) {
  ._1Ulqal .M_Zb3e {
    margin-left: calc(var(--xds-spacing-f)*-1 + var(--xds-spacing-c)*-1)
  }
}

@media screen and (min-width: 1281px) {
  ._1Ulqal .M_Zb3e {
    margin-left: 0
  }
}

._3t4r_e {
  margin: var(--xds-spacing-c) var(--xds-spacing-a);
  margin-right: var(--xds-spacing-c)
}

.DzFUap {
  position: relative;
  top: var(--xds-spacing-c)
}

@-webkit-keyframes _3PV7lK {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3PV7lK {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes MPoyMb {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes MPoyMb {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _15p2pP {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _15p2pP {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2mH6KD {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2mH6KD {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.ReOS7u {
  display: inline-block;
  position: relative;
  top: var(--xds-spacing-c)
}

.ReOS7u div {
  height: 66px
}

.KD9ga3 div:first-child {
  border-radius: var(--xds-radius-rounded-b);
  height: 66px;
  margin-bottom: var(--xds-spacing-c)
}

@-webkit-keyframes _2lL6-B {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2lL6-B {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1wCNOp {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1wCNOp {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3OJP_x {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3OJP_x {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3ZXu1b {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3ZXu1b {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3W3RHd {
  position: relative;
  width: 100%
}

.Ft7XdY {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  border-radius: var(--xds-radius-rounded-b);
  display: -webkit-box;
  display: flex;
  flex-direction: column;
  width: 122px
}

.Ft7XdY:hover:not(._3BdKbh) ._1MVKIS {
  opacity: 1;
  -webkit-transform: translate3d(4px, 0, 0) scale(1);
  transform: translate3d(4px, 0, 0) scale(1);
  width: var(--xds-icon-size-01)
}

.Ft7XdY figure {
  left: 0;
  max-height: 100%;
  max-width: 100%;
  position: absolute;
  top: 0
}

._38xSNR,
.Ft7XdY figure div {
  border-radius: var(--xds-radius-rounded-b);
  height: 66px;
  margin: var(--xds-spacing-c) var(--xds-spacing-a);
  width: 114px
}

.Qx01_C {
  display: -webkit-inline-box;
  display: inline-flex;
  margin-top: 0;
  position: relative
}

._1MVKIS {
  margin-right: 2px;
  opacity: 0;
  -webkit-transform: translate3d(-4px, 0, 0) scale(.5);
  transform: translate3d(-4px, 0, 0) scale(.5);
  -webkit-transition: opacity .2s ease-in-out, width .2s ease-in-out, -webkit-transform .2s ease-in-out;
  transition: opacity .2s ease-in-out, width .2s ease-in-out, -webkit-transform .2s ease-in-out;
  transition: transform .2s ease-in-out, opacity .2s ease-in-out, width .2s ease-in-out;
  transition: transform .2s ease-in-out, opacity .2s ease-in-out, width .2s ease-in-out, -webkit-transform .2s ease-in-out;
  width: 0;
  will-change: transform, opacity
}

._1MVKIS,
._3X4nGl {
  color: var(--xds-color-content-default)
}

._3X4nGl {
  font-size: var(--xds-font-size-14);
  -webkit-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
  line-height: var(--xds-font-size-14-line-height);
  overflow-wrap: anywhere;
  -webkit-transform: translate3d(4px, 0, 0);
  transform: translate3d(4px, 0, 0);
  -webkit-transition: -webkit-transform .2s ease-in-out;
  transition: -webkit-transform .2s ease-in-out;
  transition: transform .2s ease-in-out;
  transition: transform .2s ease-in-out, -webkit-transform .2s ease-in-out;
  will-change: transform
}

._3aAueG {
  pointer-events: none
}

._3BdKbh ._1MVKIS {
  opacity: 1;
  -webkit-transform: translate3d(4px, 0, 0) scale(1);
  transform: translate3d(4px, 0, 0) scale(1);
  width: var(--xds-icon-size-01)
}

._3BdKbh ._3X4nGl {
  color: var(--xds-color-content-positive)
}

._2GbepN div:first-child {
  border-radius: var(--xds-radius-rounded-b);
  margin-bottom: var(--xds-spacing-c)
}

@-webkit-keyframes _2gn05X {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2gn05X {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2FLalt {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2FLalt {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2TVN4P {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2TVN4P {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes EmPVXZ {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes EmPVXZ {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._35xHuM {
  margin-right: var(--xds-spacing-c)
}

@-webkit-keyframes _1UwwMo {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1UwwMo {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _9Z51Rr {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _9Z51Rr {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2Rirfc {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2Rirfc {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3y3913 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3y3913 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.R1UFys {
  -webkit-box-align: center;
  align-items: center;
  background-color: var(--xds-color-container-default);
  display: -webkit-box;
  display: flex
}

._12KWQo {
  margin: 0 auto;
  max-width: 1280px;
  padding: var(--xds-spacing-c) var(--xds-spacing-d) var(--xds-spacing-b) var(--xds-spacing-d);
  position: relative;
  width: 100%
}

@media screen and (min-width: 1025px) {
  ._12KWQo {
    padding-bottom: var(--xds-spacing-a);
    padding-top: var(--xds-spacing-a)
  }

  ._1UPU0N {
    padding-bottom: var(--xds-spacing-b);
    padding-top: 0
  }
}

@-webkit-keyframes _3QqWcx {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3QqWcx {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1LjKow {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1LjKow {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes So-K7b {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes So-K7b {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes xSZf7T {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes xSZf7T {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.fiL0Nj {
  display: inline;
  font-weight: 400
}

@-webkit-keyframes _1oqFz3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1oqFz3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3u-FRM {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3u-FRM {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1onR9h {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1onR9h {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _10ZGTq {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _10ZGTq {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1MoNXj {
  position: relative
}

@-webkit-keyframes _1Oglm1 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1Oglm1 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes t6ppPb {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes t6ppPb {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1pI5YG {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1pI5YG {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2QtpQ3 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2QtpQ3 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3iscaP {
  position: relative
}

@-webkit-keyframes xvoQaS {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes xvoQaS {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2nGjZ8 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2nGjZ8 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3prJC4 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3prJC4 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3Pf86Q {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3Pf86Q {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2FuBPJ {
  position: relative
}

@-webkit-keyframes _3NPI52 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3NPI52 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1H9XYn {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1H9XYn {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3VUMT3 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3VUMT3 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes vcAChd {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes vcAChd {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3TlcPg {
  clip: rect(1px, 1px, 1px, 1px);
  -webkit-clip-path: inset(1px);
  clip-path: inset(1px);
  display: block;
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px
}

._1hn1e6 fieldset {
  padding: 0
}

@-webkit-keyframes _2Rvhuf {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2Rvhuf {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _10lpGJ {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _10lpGJ {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2OVDsj {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2OVDsj {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes LoLEzc {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes LoLEzc {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2TJ5qD {
  display: inline-block;
  white-space: nowrap
}

@-webkit-keyframes it0KwU {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes it0KwU {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _38uzCF {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _38uzCF {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3xVRlO {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3xVRlO {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes c77FUo {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes c77FUo {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3KtqWD+._3KtqWD {
  margin-top: var(--xds-spacing-d)
}

._240tOg {
  position: relative
}

._3OImnq {
  background-color: var(--xds-color-container-strong);
  border-radius: var(--xds-spacing-c);
  bottom: var(--xds-spacing-d);
  height: calc(var(--xds-spacing-g) + var(--xds-spacing-b));
  left: var(--xds-spacing-d);
  position: absolute;
  width: calc(var(--xds-spacing-g) + var(--xds-spacing-b))
}

@-webkit-keyframes _3XnPLr {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3XnPLr {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3Aa3aX {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3Aa3aX {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _291E8X {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _291E8X {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes DrAwbf {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes DrAwbf {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3yNO4j {
  list-style: none;
  margin: 0;
  padding: 0
}

._3yNO4j._1UUkT5 {
  padding-bottom: calc(var(--xds-spacing-b) + var(--xds-spacing-f))
}

._2ro375+._2ro375 {
  margin-top: var(--xds-spacing-d)
}

@-webkit-keyframes _2KOyUt {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2KOyUt {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1PNLm_ {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1PNLm_ {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes lfdTdf {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes lfdTdf {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2V2YiD {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2V2YiD {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.K1oAUQ {
  height: 3.5rem;
  position: relative;
  width: 3.5rem
}

@-webkit-keyframes _32kjn1 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _32kjn1 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes Z1wsOP {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes Z1wsOP {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1mDcpt {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1mDcpt {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3YvXgQ {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3YvXgQ {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._38Z_zs+._38Z_zs {
  margin-top: var(--xds-spacing-b)
}

@media screen and (min-width: 1025px) {
  ._38Z_zs+._38Z_zs {
    margin-top: var(--xds-spacing-d)
  }
}

._1sU_oC {
  margin-bottom: var(--xds-spacing-b);
  word-break: break-word
}

.UOiiUi {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-box-pack: justify;
  align-content: flex-start;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
  position: relative
}

._2PiEJR,
.UOiiUi {
  display: -webkit-box;
  display: flex
}

._2PiEJR {
  -webkit-box-pack: start;
  -webkit-box-align: center;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-bottom: var(--xds-spacing-a)
}

.wbmyji {
  left: var(--xds-spacing-a);
  position: absolute;
  top: var(--xds-spacing-a)
}

@media screen and (min-width: 1025px) {
  .wbmyji {
    left: var(--xds-spacing-b);
    top: var(--xds-spacing-b)
  }
}

._3Pp6WJ {
  margin-right: var(--xds-spacing-b)
}

._3Pp6WJ,
.ugxhX4 {
  display: inline-block;
  vertical-align: middle
}

@-webkit-keyframes RaKxis {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes RaKxis {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2F8nrl {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2F8nrl {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes YIMZxg {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes YIMZxg {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1-mWcx {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1-mWcx {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1bWyy5 {
  height: calc(var(--xds-spacing-b)*2.25);
  overflow: hidden;
  text-overflow: ellipsis
}

._29o_F2 {
  background: var(--xds-color-yellow);
  border-radius: var(--xds-radius-rounded-e);
  line-height: var(--xds-line-height-null);
  margin-right: var(--xds-spacing-a);
  padding: 2px
}

@-webkit-keyframes _2P3jSh {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2P3jSh {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes gZUnDR {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes gZUnDR {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3ktlh6 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3ktlh6 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2cCYVx {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2cCYVx {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3-Hem1 {
  margin: calc(var(--xds-spacing-c)*-1) calc(var(--xds-spacing-c)*-1) 0 calc(var(--xds-spacing-c)*-1);
  position: relative
}

@media screen and (min-width: 1025px) {
  ._3-Hem1 {
    margin: calc(var(--xds-spacing-d)*-1) 0 calc(var(--xds-spacing-d)*-1) calc(var(--xds-spacing-d)*-1)
  }
}

@-webkit-keyframes _2KPa80 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2KPa80 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _13QfMQ {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _13QfMQ {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3FDcmQ {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3FDcmQ {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes vH8DbI {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes vH8DbI {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1XmYVy div {
  border: none;
  margin-right: var(--xds-spacing-a)
}

._1XmYVy div:last-child {
  margin-right: 0
}

@-webkit-keyframes _2pjBBU {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2pjBBU {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes jj3tWa {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes jj3tWa {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2o15j- {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2o15j- {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1KsND7 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1KsND7 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1O8JML {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  display: -webkit-box;
  display: flex;
  flex-direction: column
}

@media screen and (min-width: 1025px) {
  ._1O8JML {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    flex-direction: row
  }
}

._278vVO {
  padding-top: var(--xds-spacing-c);
  position: relative
}

@media screen and (min-width: 1025px) {
  ._278vVO {
    padding-left: var(--xds-spacing-e);
    padding-top: 0;
    width: 100%
  }
}

._25UK-Y {
  position: relative
}

.BLV_r6 {
  right: var(--xds-spacing-d);
  top: var(--xds-spacing-d)
}

._3Jdrr1,
.BLV_r6 {
  position: absolute
}

._3Jdrr1 {
  left: var(--xds-spacing-a);
  top: var(--xds-spacing-a)
}

@media screen and (min-width: 1025px) {
  ._3Jdrr1 {
    left: 0;
    top: 0
  }
}

@-webkit-keyframes _2UWj1T {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2UWj1T {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes ZGXHkQ {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes ZGXHkQ {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1ybAnq {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1ybAnq {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2cUGz7 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2cUGz7 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2n6uQF {
  margin-top: var(--xds-spacing-d)
}

.fmb7G2 {
  position: absolute;
  right: var(--xds-spacing-d);
  top: var(--xds-spacing-d)
}

.ZQKILX {
  margin: var(--xds-spacing-c) 0
}

@-webkit-keyframes -yRGLC {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes -yRGLC {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1mOQsG {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1mOQsG {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes siZ5df {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes siZ5df {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1M2NCL {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1M2NCL {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2rIbuV {
  margin-top: var(--xds-spacing-d)
}

._3NRn1E {
  position: absolute;
  right: var(--xds-spacing-d);
  top: var(--xds-spacing-d)
}

._3zaBAi {
  margin: var(--xds-spacing-c) 0
}

@-webkit-keyframes SVhGpq {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes SVhGpq {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1sGRLu {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1sGRLu {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1tBjAS {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1tBjAS {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3C_K4M {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3C_K4M {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1dbKva {
  background-color: var(--xds-color-background-default);
  border-radius: var(--xds-radius-rounded-b);
  color: var(--xds-color-content-default);
  font-weight: var(--xds-font-weight-bold);
  margin-right: var(--xds-spacing-d);
  padding: var(--xds-spacing-c)
}

._1dbKva._3Zo6_n {
  flex-basis: 100%;
  max-width: 100%
}

._1dbKva._1CYQ7V {
  flex-basis: calc(50% - var(--xds-spacing-c));
  max-width: calc(50% - var(--xds-spacing-c))
}

._1dbKva._1v-zOK {
  flex-basis: calc(33.3% - var(--xds-spacing-c));
  max-width: calc(33.3% - var(--xds-spacing-c))
}

._1dbKva._20pavy {
  margin-right: 0
}

@-webkit-keyframes _29LpHd {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _29LpHd {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes eUtJt7 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes eUtJt7 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _399z2d {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _399z2d {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2lKw4Q {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2lKw4Q {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3y2wwU {
  position: relative;
  z-index: 1
}

@-webkit-keyframes _1UJG9H {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1UJG9H {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _3gLIVw {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _3gLIVw {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes zyoloi {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes zyoloi {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2En44i {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2En44i {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.lN6ZdI+.lN6ZdI {
  margin-top: var(--xds-spacing-d)
}

@media screen and (min-width: 1025px) {
  .lN6ZdI+.lN6ZdI {
    margin-top: var(--xds-spacing-e)
  }
}

._2UMJXf {
  margin-bottom: var(--xds-spacing-b)
}

._1vKGK9 {
  clip: rect(1px, 1px, 1px, 1px);
  -webkit-clip-path: inset(1px);
  clip-path: inset(1px);
  display: block;
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px
}

@-webkit-keyframes _3zHC_L {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3zHC_L {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2bQgeW {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2bQgeW {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3Kt20h {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3Kt20h {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _11SO0y {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _11SO0y {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._17i2rx {
  -webkit-box-pack: justify;
  -webkit-box-align: center;
  align-items: center;
  background-color: var(--xds-color-container-default);
  bottom: 0;
  -webkit-box-shadow: var(--xds-elevation-05);
  box-shadow: var(--xds-elevation-05);
  display: -webkit-box;
  display: flex;
  height: var(--xds-spacing-h);
  justify-content: space-between;
  left: 0;
  padding: 0 var(--xds-spacing-d);
  position: fixed;
  width: 100%;
  z-index: var(--z-index-sticky)
}

._17i2rx._3SYgNg {
  justify-content: space-around;
  padding: 0
}

._2hlsDb {
  -webkit-box-align: center;
  -webkit-box-pack: center;
  align-items: center;
  justify-content: center
}

@-webkit-keyframes _1xJ846 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1xJ846 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes gGHZkw {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes gGHZkw {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes xTZoki {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes xTZoki {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes i4UsFe {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes i4UsFe {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.kfyeY- {
  -webkit-box-pack: justify;
  background-color: var(--xds-color-container-default);
  display: -webkit-box;
  display: flex;
  height: var(--xds-spacing-h);
  justify-content: space-between;
  padding: 0;
  width: 100%
}

.kfyeY-.THVbU8 {
  -webkit-box-align: end;
  align-items: flex-end;
  padding-bottom: var(--xds-spacing-a)
}

.kfyeY-._3Ey_-7 {
  -webkit-box-align: start;
  align-items: flex-start;
  padding-top: var(--xds-spacing-a)
}

._2szCYp {
  -webkit-box-align: center;
  -webkit-box-pack: center;
  -webkit-box-flex: 2;
  align-items: center;
  flex: 2 1 auto;
  justify-content: center;
  text-align: right
}

._2szCYp:first-child {
  min-width: 85%
}

@-webkit-keyframes _3T3ISI {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3T3ISI {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes vCnqDe {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes vCnqDe {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1uRrrh {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1uRrrh {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _349UTt {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _349UTt {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.nizvnE {
  font-size: var(--xds-font-body-l-size);
  font-weight: 700
}

.nizvnE ._7WiN7L {
  font-weight: 400
}

@-webkit-keyframes _32DXKp {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _32DXKp {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes idTM89 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes idTM89 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2t2Itm {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2t2Itm {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes crFbKg {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes crFbKg {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@media screen and (min-width: 1025px) {
  ._1xTLr0 {
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -webkit-box-align: center;
    align-items: center;
    display: -webkit-box;
    display: flex;
    flex-direction: row
  }
}

._1ByBX4 {
  margin-bottom: var(--xds-spacing-b);
  margin-right: 0
}

@media screen and (min-width: 1025px) {
  ._1ByBX4 {
    margin-bottom: 0;
    margin-right: var(--xds-spacing-d)
  }
}

._2Y7iOV {
  width: 100%
}

@media screen and (min-width: 1025px) {
  ._2Y7iOV {
    width: 14rem
  }
}

@-webkit-keyframes _15jkc2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _15jkc2 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2qHKVK {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2qHKVK {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes hQAbY3 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes hQAbY3 {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _29s5zO {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _29s5zO {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2yQ7y2 {
  background: var(--xds-color-container-default);
  border-top: 1px solid var(--xds-color-divider-default);
  padding: var(--xds-spacing-c) var(--xds-spacing-d)
}

._1HftXS {
  height: var(--xds-spacing-f);
  padding: var(--xds-spacing-b)
}

@-webkit-keyframes _37K-lj {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _37K-lj {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _15Sh_r {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _15Sh_r {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3c-uYY {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3c-uYY {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes Z_Lby4 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes Z_Lby4 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

fieldset {
  padding: 0
}

@-webkit-keyframes _3Hl48o {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3Hl48o {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _124Au5 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _124Au5 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1ezEST {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1ezEST {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes ZOmGw6 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes ZOmGw6 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2XUNYq {
  display: -webkit-box;
  display: flex;
  height: 100%;
  margin: auto;
  max-width: calc(1232px + var(--xds-spacing-d))
}

@media screen and (min-width: 1025px) {
  ._2XUNYq {
    padding-top: var(--xds-spacing-b)
  }
}

._2XUNYq.lLqqFS {
  padding-top: var(--xds-spacing-a)
}

.XxhyH1 {
  display: none;
  min-height: 700px;
  width: 328px
}

@media screen and (min-width: 1025px) {
  .XxhyH1 {
    display: block;
    margin-right: var(--xds-spacing-d)
  }
}

.tLKB6r {
  margin: calc(var(--xds-spacing-d)*-1) 0;
  padding: var(--xds-spacing-d) 0
}

._3lXnmO {
  margin: 0 auto;
  max-width: 540px;
  width: 100%
}

@media screen and (min-width: 1025px) {
  ._3lXnmO {
    max-width: 904px
  }
}

._3lXnmO._2jmgEf {
  margin-top: calc(var(--xds-spacing-d)*-1)
}

._2zzjWz {
  display: none
}

@media screen and (min-width: 1025px) {
  ._2zzjWz {
    display: block
  }
}

._2uFfXk {
  background-color: var(--xds-color-container-default);
  overflow: hidden;
  padding: 0 var(--xds-spacing-d)
}

[data-qa=cuisine-filter]+._2uFfXk {
  padding-top: 0
}

@media screen and (min-width: 1025px) {
  ._3lXnmO {
    width: calc(100% - 328px - var(--xds-spacing-d))
  }
}

._2QccIV>[data-qa=sticky]>div>div {
  position: relative
}

.W71Ff5 {
  -webkit-box-shadow: var(--xds-elevation-03);
  box-shadow: var(--xds-elevation-03);
  width: calc(100% + var(--xds-spacing-d)*2)
}

._1DdqrS {
  padding: var(--xds-spacing-f) 0
}

._2lqZUs {
  height: 1px;
  position: relative;
  width: 100%
}

._3PdoXA {
  margin-left: calc(var(--xds-spacing-d)*-1);
  margin-right: calc(var(--xds-spacing-d)*-1);
  padding: 0 var(--xds-spacing-d);
  width: calc(100% + var(--xds-spacing-d)*2)
}

._3FIq95 {
  -webkit-box-shadow: var(--xds-elevation-03);
  box-shadow: var(--xds-elevation-03);
  z-index: 2
}

@-webkit-keyframes _1n7r1x {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1n7r1x {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1nr4cT {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1nr4cT {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1WvWmt {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1WvWmt {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1ViVv0 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1ViVv0 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3P6fJf {
  -webkit-box-align: center;
  align-items: center;
  background-color: var(--xds-color-container-default);
  border-radius: var(--xds-spacing-b);
  bottom: 100%;
  display: -webkit-inline-box;
  display: inline-flex;
  left: 11.54%;
  margin-bottom: var(--xds-spacing-d);
  position: absolute
}

._3QvnlD {
  bottom: 0;
  left: 0;
  margin: var(--xds-spacing-d);
  margin-bottom: var(--xds-spacing-e);
  position: absolute;
  right: 0
}

@media screen and (min-width: 1025px) {
  ._3QvnlD {
    margin: var(--xds-spacing-d) 11.54% var(--xds-spacing-d) 11.54%
  }
}

@media screen and (min-width: 1025px) and (min-width:1025px) {
  ._3QvnlD {
    margin-bottom: var(--xds-spacing-f)
  }
}

@media screen and (min-width: 1025px) {
  ._3QvnlD._1CxexI {
    max-width: none;
    width: 100%
  }
}

._3QvnlD._1CxexI {
  margin: 0 0 var(--xds-spacing-d);
  margin-bottom: var(--xds-spacing-e)
}

@media screen and (min-width: 1025px) {
  ._3QvnlD._1CxexI {
    margin: 0 0 var(--xds-spacing-g)
  }
}

@-webkit-keyframes _145-EJ {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _145-EJ {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2owVlJ {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2owVlJ {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _1zN_7H {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _1zN_7H {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3KOnzF {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3KOnzF {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.cluster-2 {
  -webkit-box-pack: center;
  -webkit-box-align: center;
  align-items: center;
  display: -webkit-box;
  display: flex;
  justify-content: center
}

.cluster-2 span {
  color: var(--xds-color-content-brand);
  position: relative;
  top: 2px
}

.cluster-0 span,
.cluster-2 span {
  font-family: JETSansDigital, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: var(--xds-font-heading-m-size--narrow)
}

.cluster-0 span {
  color: var(--xds-color-content-light)
}

._1YSgqe {
  font-family: JETSansDigital, -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Helvetica, Arial, sans-serif;
  margin-bottom: var(--xds-spacing-e);
  margin-top: var(--xds-spacing-e);
  width: 150px
}

._3eHDW3 {
  background-color: var(--xds-color-container-default);
  border-radius: var(--xds-radius-rounded-b);
  left: 20px;
  position: relative;
  top: 20px;
  width: 28px
}

._2NBHL6 {
  height: 28px
}

._1-OYZY {
  padding: 0 var(--xds-spacing-a);
  width: 100%
}

._2-OMR9 {
  height: 100%;
  width: 100%
}

._24jhCg {
  opacity: .2;
  pointer-events: none
}

._2jWVoi {
  bottom: 0;
  left: 0;
  margin: var(--xds-spacing-d);
  position: absolute;
  right: 0
}

@media screen and (min-width: 1025px) {
  ._2jWVoi {
    margin: var(--xds-spacing-f) auto;
    max-width: calc(100% - var(--xds-spacing-f)*2);
    width: 720px
  }
}

@-webkit-keyframes _3nilYR {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _3nilYR {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2JWzTw {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2JWzTw {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2gH5Se {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2gH5Se {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3QHgj2 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3QHgj2 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._166YR6 {
  margin: calc(var(--xds-spacing-d)*-1);
  position: relative
}

@media screen and (min-width: 1025px) {
  ._166YR6 {
    margin: 0;
    padding-bottom: var(--xds-spacing-d)
  }
}

._1BzHfj {
  margin: 0
}

._2kAk2G {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0
}

@-webkit-keyframes _2d62B7 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2d62B7 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1SeZ7p {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1SeZ7p {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _2vx-Eh {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _2vx-Eh {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _1MV1g5 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _1MV1g5 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@-webkit-keyframes _3Perre {
  50% {
    opacity: .4
  }

  to {
    opacity: .7
  }
}

@keyframes _3Perre {
  50% {
    opacity: .4
  }

  to {
    opacity: .7
  }
}

._PMy2- {
  -webkit-animation: _3Perre 2s infinite;
  animation: _3Perre 2s infinite;
  height: 100%;
  opacity: .7;
  width: 100%
}

@-webkit-keyframes _35sC-J {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _35sC-J {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _18coeD {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _18coeD {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3SxL8F {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3SxL8F {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2yHxbf {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2yHxbf {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._22Tc-d {
  text-align: center
}

._3_e6O3 {
  background-color: var(--xds-color-background-default);
  border-radius: calc(var(--xds-radius-rounded-c) + var(--xds-radius-rounded-d));
  -webkit-box-shadow: 0 2px 6px rgba(0, 0, 0, .04), 0 8px 12px -2px rgba(0, 0, 0, .06);
  box-shadow: 0 2px 6px rgba(0, 0, 0, .04), 0 8px 12px -2px rgba(0, 0, 0, .06);
  display: inline-block;
  font-size: var(--xds-font-heading-m-size--narrow);
  font-weight: 700;
  margin-bottom: var(--xds-spacing-d);
  padding: var(--xds-spacing-a) var(--xds-spacing-b)
}

._3_e6O3 [data-qa=map-button] {
  display: inline-block;
  margin-right: var(--xds-spacing-b)
}

@-webkit-keyframes _30YgvT {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _30YgvT {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _315cFW {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _315cFW {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes Z5Cwrj {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes Z5Cwrj {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _18AoPd {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _18AoPd {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._1aWt-0 {
  padding: var(--xds-spacing-b)
}

._8g1TyJ {
  color: var(--xds-color-content-light);
  cursor: pointer
}

@-webkit-keyframes _2zSYbC {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2zSYbC {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2w1__B {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2w1__B {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _31YyNw {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _31YyNw {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2lhVBF {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2lhVBF {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.A5ilJ3 {
  background-color: var(--xds-color-support-brand-06);
  margin-bottom: var(--xds-spacing-d);
  min-height: 85px
}

@media screen and (min-width: 1025px) {
  .A5ilJ3 {
    margin-bottom: 0
  }
}

.A5ilJ3 [role=alert]>div>div {
  padding: 0 0 0 .5rem
}

.A5ilJ3 [role=alert]>div>div>div>div {
  margin: 0 auto;
  max-width: 1180px;
  width: 100%
}

@-webkit-keyframes _1flpp6 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1flpp6 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes JzB_lK {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes JzB_lK {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes uQtrSs {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes uQtrSs {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _3fnNsP {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _3fnNsP {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

.tpBMP9 [role=dialog]>div {
  background-color: var(--xds-color-support-brand-06)
}

._1CIkVO {
  margin: 0 auto;
  max-width: 460px;
  padding-bottom: 48px
}

.ZLifo3 {
  -webkit-box-pack: end;
  background-color: var(--xds-color-support-brand-06);
  justify-content: flex-end;
  padding: var(--xds-spacing-d);
  width: 100%
}

._3IOALR,
.ZLifo3 {
  display: -webkit-box;
  display: flex
}

._3IOALR {
  -webkit-box-pack: center;
  -webkit-box-align: center;
  align-items: center;
  justify-content: center;
  width: 200px
}

@media screen and (min-width: 1024px) {
  ._3IOALR {
    width: 300px
  }
}

@-webkit-keyframes _1EG_ug {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _1EG_ug {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _2NPtRm {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _2NPtRm {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3Uo_aF {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3Uo_aF {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2bIoVn {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2bIoVn {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._8IX9KT {
  word-break: break-word
}

._1fQ6-u {
  min-height: 5rem;
  position: relative
}

@-webkit-keyframes _2iUnjh {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _2iUnjh {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes _1cgPu3 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes _1cgPu3 {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes _3S3Edt {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes _3S3Edt {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes _2Jo3QW {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes _2Jo3QW {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._3dJLuK [data-qa=location-panel-search-panel] [data-focus-visible-added]:focus>div {
  -webkit-box-shadow: inset 0 0 0 2px var(--xds-color-focus-outer) !important;
  box-shadow: inset 0 0 0 2px var(--xds-color-focus-outer) !important
}

@-webkit-keyframes _13cGi3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@keyframes _13cGi3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg)
  }

  to {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn)
  }
}

@-webkit-keyframes DhjaLw {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@keyframes DhjaLw {
  0% {
    -webkit-transform: translateX(-100%);
    transform: translateX(-100%)
  }

  to {
    -webkit-transform: translateX(100%);
    transform: translateX(100%)
  }
}

@-webkit-keyframes xsFcBa {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@keyframes xsFcBa {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, .7);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }

  70% {
    -webkit-box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 10px rgba(243, 104, 5, 0);
    -webkit-transform: scale(1);
    transform: scale(1)
  }

  to {
    -webkit-box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    box-shadow: 0 0 0 0 rgba(243, 104, 5, 0);
    -webkit-transform: scale(.95);
    transform: scale(.95)
  }
}

@-webkit-keyframes uQknZ3 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

@keyframes uQknZ3 {
  0% {
    background-size: 100% 0
  }

  to {
    background-size: 100% 100%
  }
}

._2fXYV2 {
  padding: var(--xds-spacing-c) 0 var(--xds-spacing-d)
}

._2uqL9d {
  -webkit-box-pack: end;
  justify-content: flex-end;
  padding: var(--xds-spacing-d);
  width: 100%
}

._2UAErG,
._2uqL9d {
  display: -webkit-box;
  display: flex
}

._2UAErG {
  -webkit-box-pack: center;
  -webkit-box-align: center;
  align-items: center;
  justify-content: center;
  margin-bottom: var(--xds-spacing-e)
}

._2UAErG img {
  max-height: 200px
}

._1WVJop ._2uqL9d,
._1WVJop [role=dialog]>div {
  background-color: var(--xds-color-support-brand-03);
  color: var(--xds-color-content-default)
}

._3BziRs ._2uqL9d,
._3BziRs [role=dialog]>div {
  background-color: var(--xds-color-support-brand-05);
  color: var(--xds-color-content-default)
}

._9SQ_4p ._2uqL9d,
._9SQ_4p [role=dialog]>div {
  background-color: var(--xds-color-support-brand-06);
  color: var(--xds-color-content-light)
}

._9SQ_4p ._3Axq8U>a,
._9SQ_4p ._3Axq8U>a:focus,
._9SQ_4p ._3Axq8U>a:hover,
._9SQ_4p ._3jm01G>span,
._9SQ_4p span,
._9SQ_4p span:focus,
._9SQ_4p span:hover {
  color: var(--xds-color-content-light)
}

._9SQ_4p ._2eEdtl>button,
._9SQ_4p ._2eEdtl>button:focus,
._9SQ_4p ._2eEdtl>button:hover,
._9SQ_4p span,
._9SQ_4p span:focus,
._9SQ_4p span:hover {
  color: var(--xds-color-container-dark)
}

._1Lhhat ._2uqL9d,
._1Lhhat [role=dialog]>div {
  background-color: var(--xds-color-container-dark);
  color: var(--xds-color-content-light)
}

._1Lhhat ._3Axq8U>a,
._1Lhhat ._3Axq8U>a:focus,
._1Lhhat ._3Axq8U>a:hover,
._1Lhhat ._3jm01G>span,
._1Lhhat span,
._1Lhhat span:focus,
._1Lhhat span:hover {
  color: var(--xds-color-content-light)
}

._1Lhhat ._2eEdtl>button,
._1Lhhat ._2eEdtl>button:focus,
._1Lhhat ._2eEdtl>button:hover,
._1Lhhat span,
._1Lhhat span:focus,
._1Lhhat span:hover {
  color: var(--xds-color-container-dark)
}

._1-4xFd ._2uqL9d,
._1-4xFd [role=dialog]>div {
  background-color: var(--xds-color-support-brand-04);
  color: var(--xds-color-content-default)
}

._1t6RQq ._2uqL9d,
._1t6RQq [role=dialog]>div {
  background-color: var(--xds-color-container-strong);
  color: var(--xds-color-content-default)
}</style>